import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Pagination from "../../../utils/pagination";
import {
  exhibitorList_action,
  getExhiitorDetails_action,
  generatePriorityNo_action,
  submitManualPriorityNo_action,
  sendUserCred_action,
  submitAutoPriorityNo_action,
  generateHallNoStallNo_action,
  generateOpenSide_action,
  getExhRegList_action,
  removedEdirectoryManual_action,
  addEdirectoryManual_action,
  addFasciaManual_action,
  activateDeactivateExhibitors_action,
  SSIDocumentApproval_action,
  updateStallTypeArea_action,
  submitOpenSidePI_action,
  sendhallstallUserCred_action,
  submitDiscount_action,
  sendRevisedPI_action,
  viewRevisedPI_action, getAPDetails_action,
  insertUpdateAP_action,
  generateRevisedPI_action, removeHallStall_action
} from "../../../actions/admin_module_action/exhibitor_list_action/exhibitor_list_action";
import { createExhSendCredLog_action, getExhSendCredLog_action } from "../../../actions/exhSendCredLog_action/exhSendCredLog_action";
import {
  agentListActionId,
  boothTypeActionId,
  countryActionId,
  downloadReport,
  exhibitorTypeActionId,
  fetchAuthReport,
  hallListActionId,
  hallNoActionId,
  hallNoList,
  loginUrl,
  manualFormDoc,
  paymentTypeActionId,
  primaryChapterActionId,
  priorityNoActionId,
  stallNoListActionId,
  statusTypeActionId,
  toastError,
  toastSuccess,
  segmentActionId,
  exhibitionActionId,
  hallMasterListActionId,
  stallSizeActionId,
  stallTypeActionId,
  bareShellDateActionId, isOtherAreaActionId,
  DOC_BASE_URL
} from "../../../utils/constants";
import Modal from "react-modal";
import { data } from "jquery";
import {
  descriptionPreview_action,
  bulkDescriptionPreview_action,
} from "../../../actions/description_action";
import {
  fill_action,
  fill_master_action,
} from "../../../actions/fillCombo_action";
import Workbook from "react-excel-workbook";
import { axiosPost } from "../../../react_axios/Axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Switch } from "antd";

const ExampleCustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      value={value}
      className="form-control"
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    ></input>
  )
);

class ExhibitorList extends Component {
  // intialize constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      checkedAll: false,
      showForRegistration: false,
      currentPage: 1,
      startIndex: 0,
      isOpen: false,
      isDetailOpen: false,
      isFromDashboard: false,
      exhibitor: "",
      exhibition: "",
      exhibitorList: [],
      estimateDetails: [],
      generatePriorityNoType: 1,
      priorityNoList: [],
      paymentTypeList: [],
      priorityNoId: "",
      paymentTypeId: "",
      priorityNoErr: "",
      exhregId: "",
      exhibitorOutstanding: "",
      exhRegList: [],
      isOpen2: false,
      isOpen3: false,
      isOpen4: false,
      isOpen5: false,
      isOpen6: false,
      isOpen7: false,
      isOpen8: false,
      sendRevisedPIID: "",
      hallNo: "",
      stallNo: "",
      openSide: "",
      statusCount: [],
      userName: "",
      statusID: "",
      statusTypeList: [],
      exhibitorTypeId: "",
      exhibitorTypeList: [],
      boothTypeList: [],
      hallNoList: [],
      boothTypeId: "",
      hallNumber: "",
      agentList: [],
      agentId: "",
      chapterList: [],
      chapter: "",
      countryList: [],
      loginAccesslist: [],
      hallList: [],
      stallList: [],
      countryId: "",
      exhREgNo: "",
      stallNumber: "",
      fromArea: "",
      toArea: "",
      tabName: "",
      keyword: "",
      exhibitorArea: "",
      hallSegmentList: [],
      hallMasterList: [],
      // Err Messages
      hallNoErr: "",
      stallNoErr: "",
      openSideErr: "",

      exhibitionList: [],
      exhibitionID: "",
      SSIStatus: "",
      RejectReason: "",
      SSIexhID: "",
      discountPercent: "",
      // discountPercentErr: '',
      discountAmt: "",
      discountErr: "",
      discountExhibitonID: "",
      openSidePIExhibitionID: "",

      schemeTypeList: [],
      schemeType: "",
      stallAreaList: [],
      stallAreaName: "",
      stallAreaId: "",
      stallArea: "",
      areaCountryID: "",
      areaExhibitionID: "",
      modalOpenSide: "",
      modalArea: "",
      Flag: false,
      modalData: "",
      isRevisedPIGenerated: false,
      StallpossessionScheduledDate: null,
      StallpossessionScheduledDateErr: "",
      BareStartDate: null,
      ShellStartDate: null,

      isOpenAc: false,
      areasList: [],
      accessControlList: [],
      accessControlVendorList: [],

      isOpenCredLog: false,
      exhSendCredLogList: [],
      credLogSearch: "",
      credLogCurrentPage: 1,
      removeHallStallPop: false,
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.getExhibitorList = this.getExhibitorList.bind(this);
    this.getExhibitorDetails = this.getExhibitorDetails.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleDetailModal = this.toggleDetailModal.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onDetailsClick = this.onDetailsClick.bind(this);
    this.onBulkDetailsClick = this.onBulkDetailsClick.bind(this);
    this.resendUserCred = this.resendUserCred.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.onGenerateClick = this.onGenerateClick.bind(this);
    this.onFinalGeneratePriorityNo = this.onFinalGeneratePriorityNo.bind(this);
    this.generateManualPriorityNo = this.generateManualPriorityNo.bind(this);
    this.generateAutoPriorityNo = this.generateAutoPriorityNo.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.getExhRegList = this.getExhRegList.bind(this);
    this.onCreateExcel = this.onCreateExcel.bind(this);
    this.onGenerateHallNoStallNO = this.onGenerateHallNoStallNO.bind(this);
    this.toggleModal2 = this.toggleModal2.bind(this);
    this.toggleModal3 = this.toggleModal3.bind(this);
    this.inputValidate = this.inputValidate.bind(this);
    this.genrateHallStall = this.genrateHallStall.bind(this);
    this.ChangeOpenSide = this.ChangeOpenSide.bind(this);
    this.onHallStallClick = this.onHallStallClick.bind(this);
    this.selectAllExhibitors = this.selectAllExhibitors.bind(this);
    this.handleCheckedExhibitors = this.handleCheckedExhibitors.bind(this);
    this.onAddEdirectory = this.onAddEdirectory.bind(this);
    this.onAddFascia = this.onAddFascia.bind(this);
    this.getSpecialAccess = this.getSpecialAccess.bind(this);
    this.getDownloadAccess = this.getDownloadAccess.bind(this);
    this.getWriteAccess = this.getWriteAccess.bind(this);
    this.getUpdateAccess = this.getUpdateAccess.bind(this);
    this.activateDeactivateUsers = this.activateDeactivateUsers.bind(this);
    this.onHallChange = this.onHallChange.bind(this);
    this.onAreaClick = this.onAreaClick.bind(this);
    this.toggleModal4 = this.toggleModal4.bind(this);
    this.getMasterFillList = this.getMasterFillList.bind(this);
    this.onDiscountClick = this.onDiscountClick.bind(this);
    this.onDiscountSubmit = this.onDiscountSubmit.bind(this);
    this.onDiscountChange = this.onDiscountChange.bind(this);
    this.onGenerateOpenSidePI = this.onGenerateOpenSidePI.bind(this);
    this.onPISubmit = this.onPISubmit.bind(this);
    this.onSchemeTypeChange = this.onSchemeTypeChange.bind(this);
    this.onLengthTypeChange = this.onLengthTypeChange.bind(this);
    this.onExportToExcel = this.onExportToExcel.bind(this);
    this.onUpdateStallTypeArea = this.onUpdateStallTypeArea.bind(this);
    this.onOpenAccessControlModal = this.onOpenAccessControlModal.bind(this);
    this.onViewRevisedPIClick = this.onViewRevisedPIClick.bind(this);
    this.insertUpdateAP = this.insertUpdateAP.bind(this);
    this.openCredLogModal = this.openCredLogModal.bind(this);
    this.toggleCredLogModal = this.toggleCredLogModal.bind(this);
  }

  componentDidMount() {
    this.getExhRegList();
    sessionStorage.removeItem("ExhibitorAccessData");
    this.getFillList(paymentTypeActionId, "", "", "", "", "");
    this.getFillList(bareShellDateActionId, "", "", "", "", "");
    this.getFillList(isOtherAreaActionId, "", "", "", "", "");
    this.getFillList(statusTypeActionId, "", "", "", "", "");
    this.getFillList(exhibitorTypeActionId, "", "", "", "", "");
    this.getFillList(boothTypeActionId, "", "", "", "", "");
    // this.getFillList(hallNoActionId, '', '', '', '', '');
    this.getFillList(agentListActionId, "", "", "", "", "");
    this.getFillList(primaryChapterActionId, "", "", "", "", "");
    this.getFillList(countryActionId, "", "", "", "", "");
    this.getFillList(hallMasterListActionId, "", "", "", "", "");
    this.getMasterFillList(hallMasterListActionId, "", "", "", "", "");
    this.getFillList(exhibitionActionId, "", "", "", "", "");
    this.getFillList(
      stallTypeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );

    this.setState(
      {
        tabName:
          this.props.location.state != null && this.props.location.state.tab
            ? this.props.location.state.tab
            : "",
        Flag:
          this.props.location.state != null && this.props.location.state.Flag
            ? this.props.location.state.Flag
            : false,
        isFromDashboard:
          this.props.location.state != null &&
            this.props.location.state.fromDashBoard
            ? this.props.location.state.fromDashBoard
            : false,
        keyword:
          this.props.location.state != null && this.props.location.state.keyword
            ? this.props.location.state.keyword
            : "",
        paymentTypeId:
          this.props.location.state != null &&
            this.props.location.state.paymentType
            ? this.props.location.state.paymentType
            : "",
        exhibitorTypeId:
          this.props.location.state != null &&
            this.props.location.state.exhibitorType
            ? this.props.location.state.exhibitorType
            : "",
        loginAccesslist: JSON.parse(sessionStorage.getItem("loginDataSS"))[
          "loginAccesslist"
        ],
      },
      () => {
        this.getExhibitorList(null);
      }
    );
  }

  getMasterFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    // if (actionID == countryActionId) {
    this.props
      .fill_master_action(actionID, null, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // Country List
          if (actionID === hallMasterListActionId) {
            this.setState({
              hallMasterList: data.data,
              // TempCountryList: data.data,
              // allocateCountryList: alloCountryList
            });
            // console.log("country data", alloCountryList)
          }
        }
      });
    // }
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    const { stallAreaId } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === bareShellDateActionId) {
            this.setState({
              BareStartDate: data.data[0]['BareStartDate'] ? moment(data.data[0]['BareStartDate'], "YYYY-MM-DD").toDate() : null,
              ShellStartDate: data.data[0]['ShellStartDate'] ? moment(data.data[0]['ShellStartDate'], "YYYY-MM-DD").toDate() : null,
            });
          }
          if (actionID === priorityNoActionId) {
            this.setState({
              priorityNoList: data.data,
              // isLoading: false,
            });
          }
          if (actionID === stallTypeActionId) {
            // console.log("country data", data.data)
            this.setState({
              schemeTypeList: data.data,
            });
            if (data.data.length == 1) {
              this.onSchemeTypeChange(null, data.data[0].Code);
            }
          }
          if (actionID === stallSizeActionId) {
            console.log("country data", data.data, stallAreaId);
            this.setState({
              stallAreaList: data.data,
            });
            if (stallAreaId != "") {
              for (var i = 0; i < data.data.length; i++) {
                if (data.data[i].Code == stallAreaId) {
                  console.log("Description : ", data.data[i].Description);
                  this.setState({ stallAreaName: data.data[i].Description });
                }
              }
            }
          }
          // Payment Type list
          if (actionID === paymentTypeActionId) {
            console.log("Payment Type list data", data.data);
            var list = data.data.filter((element) => element.ID != 4);
            this.setState({
              paymentTypeList: list.length > 0 ? list : [],
              // isLoading: false
            });
          }
          if (actionID === isOtherAreaActionId) {
            console.log("Payment Type list data", data.data);
            // var list = data.data.filter((element) => element.ID != 4);
            this.setState({
              areasList: data.data,
              // isLoading: false
            });
          }
          // Status Type list
          if (actionID === statusTypeActionId) {
            console.log("Status Type list data", data.data);
            this.setState({
              statusTypeList: data.data,
              // isLoading: false
            });
          }
          // Exhibitor Type list
          if (actionID === exhibitorTypeActionId) {
            console.log("Exhibitor Type list data", data.data);
            this.setState({
              exhibitorTypeList: data.data,
              // isLoading: false
            });
          }
          // Booth Type list
          if (actionID === boothTypeActionId) {
            console.log("Booth Type list data", data.data);
            this.setState({
              boothTypeList: data.data,
              // isLoading: false
            });
          }
          // hall List
          if (actionID === hallNoActionId) {
            console.log("hallNoList list data", data.data);
            this.setState({
              hallNoList: data.data,
              // isLoading: false
            });
          }
          // Agent List
          if (actionID === agentListActionId) {
            console.log("Agent list data", data.data);
            this.setState({
              agentList: data.data,
              // isLoading: false
            });
          }
          // Primary Chapter List
          if (actionID === primaryChapterActionId) {
            console.log("Primary Chapter list data", data.data);
            this.setState({
              chapterList: data.data,
              // isLoading: false
            });
          }
          // country List
          if (actionID === countryActionId) {
            console.log("country List list data", data.data);
            this.setState({
              countryList: data.data,
              // isLoading: false
            });
          }
          //exhibition
          if (actionID === exhibitionActionId) {
            this.setState({
              exhibitionList: data.data.length > 0 ? data.data : [],
              // isLoading: false
            });
          }
          // Hall List
          if (actionID === hallMasterListActionId) {
            console.log("Hall List list data", data.data);
            this.setState({
              hallList: data.data,
              // isLoading: false
            });
          }
          // Stall List
          if (actionID === stallNoListActionId) {
            console.log("Stall Posession Status list data1", value);
            console.log("Stall Posession Status list data2", exhRegistrationID);
            this.setState({
              stallList: data.data,
              isLoading: false,
            });
          }
          // segment
          if (actionID === segmentActionId) {
            console.log("segment List list data", data.data);
            this.setState({
              hallSegmentList: data.data,
              // isLoading: false
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onSchemeTypeChange(e, id) {
    console.log("id :", id);
    if (e) {
      e.preventDefault();
    }
    const { areaCountryID } = this.state;
    this.setState({
      schemeType: id,
      stallAreaId: "",
      stallAreaName: "",
      stallArea: "",
    });
    this.getFillList(
      stallSizeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      id,
      areaCountryID,
      ""
    );
    this.setState({ isLoading: false });
  }

  // For Exhibitor List
  getExhibitorList(Status) {
    const {
      exhibitor,
      exhibition,
      paymentTypeId,
      userName,
      exhibitorTypeId,
      boothTypeId,
      hallNumber,
      agentId,
      chapter,
      countryId,
      exhREgNo,
      stallNumber,
      fromArea,
      toArea,
      Flag,
      tabName,
      exhibitionID,
      modalData,
      keyword,
      isOpen2,
    } = this.state;
    this.setState({ isLoading: true });
    console.log(exhibitionID);

    this.props
      .exhibitorList_action(
        exhibitionID,
        exhibitor,
        paymentTypeId,
        Status,
        userName,
        exhibitorTypeId,
        boothTypeId,
        hallNumber,
        agentId,
        chapter,
        countryId,
        exhREgNo,
        stallNumber,
        fromArea,
        toArea,
        tabName,
        keyword
      )
      .then((data) => {
        if (data.error != 1) {
          var exhList = data.data != null && data.data["tableData"];
          exhList.length > 0 &&
            exhList.map((item) => {
              item.isSelect = false;
            });
          console.log("xxxxxxxxxxxxxx", exhList);
          if (Flag) {
            exhList = exhList.filter(
              (item) => item.isGeneratePIopenSide == true
            );
          }
          this.setState({
            exhibitorList: exhList != null && exhList,
            statusCount: data.data != null && data.data["statusCount"],
            isLoading: false,
          });

          if (isOpen2) {
            exhList.length > 0 &&
              exhList.map((item) => {
                item.ExhRegistrationID == modalData.ExhRegistrationID &&
                  this.setState({
                    modalArea: item.Area,
                    modalOpenSide: item.OpenSides,
                  });
              });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // For ExhRegistration List
  getExhRegList() {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getExhRegList_action()
      .then((data) => {
        console.log(data.data, "=<><><>");
        if (data.error != 1) {
          this.setState({
            exhRegList: data.data,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  OnSSIDocumentApprove() {
    const { SSIStatus, SSIexhID, RejectReason } = this.state;
    this.setState({ isLoading: true });
    this.props
      .SSIDocumentApproval_action(
        SSIexhID,
        SSIStatus,
        RejectReason != "" && RejectReason != null ? RejectReason : null
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            SSIexhID: "",
            SSIStatus: "",
            RejectReason: "",
            isLoading: false,
            isOpen5: false,
          });
          this.getExhibitorList(null);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // to create excel file
  onCreateExcel() {
    const { exhRegList } = this.state;

    var list = [];
    exhRegList.length > 0 &&
      exhRegList.map((data) => {
        var obj = { ...data };
        list.push(obj);
      });
    list.length > 0 &&
      list.map((data) => {
        delete data.ExhRegistrationID;
      });
    var columnArray = [],
      rowData = [];
    // for column data
    list.map((data, index) => {
      if (index == 0) {
        Object.keys(data).map((key, index) => {
          columnArray.push(key);
        });
      }
    });

    // for row data
    list.map((data, index) => {
      rowData.push(data);
    });

    // console.log("rowData", rowData)
    // this.setState({
    //     columnArrayData: columnArray,
    //     rowData: rowData
    // })

    // { this.renderList() }
    return (
      <div className="row text-center">
        {exhRegList.length > 0 ? (
          <Workbook
            filename="ExhibitorList.xlsx"
            element={
              <i
                className="fa fa-download rounded-2 export-icon"
                style={{
                  fontSize: "20px",
                  color: this.getDownloadAccess() ? "#22b2a5" : "#ccc",
                  cursor: this.getDownloadAccess() ? "pointer" : "not-allowed",
                }}
                title="Export All"
              ></i>
            }
          >
            <Workbook.Sheet data={rowData} name="Sheet A">
              {columnArray.map((value, index) => (
                <Workbook.Column label={value} value={value} />
              ))}
            </Workbook.Sheet>
          </Workbook>
        ) : (
          <i
            className="fa fa-download"
            style={{ fontSize: "20px", color: "#ccc", cursor: "not-allowed" }}
            title="Export All"
          ></i>
        )}
      </div>
    );
  }

  onExportToExcel() {
    const { exhibitorList, exhRegList } = this.state;

    var list = [];
    for (var j = 0; j < exhibitorList.length; j++) {
      if (exhibitorList[j].isSelect) {
        for (var i = 0; i < exhRegList.length; i++) {
          // console.log('exhibitorList[j].ExhRegistrationID', exhibitorList[j].ExhRegistrationID, exhRegList[i])
          if (
            exhibitorList[j].ExhRegistrationID ==
            exhRegList[i].ExhRegistrationID
          ) {
            var obj = { ...exhRegList[i] };
            list.push(obj);
          }
        }
      }
    }
    const isAvailable = exhibitorList.some((item) => item.isSelect == true);
    console.log(isAvailable);
    list.length > 0 &&
      list.map((data) => {
        delete data.ExhRegistrationID;
      });
    console.log("listlistlist", list);

    var columnArray = [],
      rowData = [];
    // for column data
    list.map((data, index) => {
      if (index == 0) {
        Object.keys(data).map((key, index) => {
          columnArray.push(key);
        });
      }
    });

    list.map((data, index) => {
      rowData.push(data);
    });

    console.log(rowData, columnArray, list);
    return (
      <>
        {isAvailable ? (
          <Workbook
            filename="ExhibitorList.xlsx"
            style={{}}
            element={
              <i
                className="fa fa-file-excel-o rounded-2 export-icon"
                style={{
                  fontSize: "24px",
                  cursor: "pointer",
                  color: this.getDownloadAccess() ? "#28a745" : "#ccc",
                }}
                title="Export to Excel"
              ></i>
            }
          >
            <Workbook.Sheet data={rowData} name="Sheet A">
              {columnArray.map((value, index) => (
                <Workbook.Column label={value} value={value} />
              ))}
            </Workbook.Sheet>
          </Workbook>
        ) : (
          <i
            className="fa fa-file-excel-o rounded-2 export-icon"
            title="Export to Excel"
          ></i>
        )}
      </>
    );
  }

  // Exhibtor Details
  getExhibitorDetails() {
    this.setState({ isLoading: true });
    this.props
      .getExhiitorDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleKeyDown(e) {
    const { statusID } = this.state;
    if (e.code == "Enter") {
      this.getExhibitorList(statusID);
    }
  }

  // Update Current Page
  updateItem(item) {
    const { exhibitorList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = exhibitorList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(exhibitorList.length / recordsPerPage);
    this.setState({ startIndex: recordsPerPage * (item - 1) });
  }

  // On Search Click
  onSearchClick() {
    const {
      exhibitor,
      exhibitionID,
      paymentTypeId,
      userName,
      statusID,
      exhibitorTypeId,
      boothTypeId,
      hallNumber,
      agentId,
      chapter,
      countryId,
      exhREgNo,
      stallNumber,
      fromArea,
      toArea,
    } = this.state;
    if (
      exhibitor != "" ||
      exhibitionID != "" ||
      paymentTypeId != "" ||
      userName != "" ||
      statusID != "" ||
      exhibitorTypeId != "" ||
      boothTypeId != "" ||
      hallNumber != "" ||
      agentId != "" ||
      chapter != "" ||
      countryId != "" ||
      exhREgNo != "" ||
      stallNumber != "" ||
      fromArea != "" ||
      toArea != ""
    ) {
      console.log(exhibitionID);
      this.getExhibitorList(statusID);
      if (exhibitionID != "" && exhibitionID != null) {
        this.getFillList(hallMasterListActionId, exhibitionID, "", "", "", "");
      }
    } else {
      toastError("Atleast Fill One field to Search");
    }
  }

  // Modal Toggle
  toggleModal() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  // Modal Toggle 2
  toggleModal2() {
    const { isOpen2 } = this.state;
    this.setState({ isOpen2: !isOpen2 });
  }

  // Modal Toggle 3
  toggleModal3() {
    const { isOpen3 } = this.state;
    this.setState({ isOpen3: !isOpen3 });
  }

  // Modal Toggle 4
  toggleModal4() {
    const { isOpen4 } = this.state;
    this.setState({ isOpen4: !isOpen4 });
  }
  toggleModalSendRevicesPI(e, id) {
    const { isOpen8, isRevisedPIGenerated } = this.state;
    this.setState({ isOpen8: !isOpen8 });
    if (id != undefined && id != null && id != "") {
      this.setState({
        sendRevisedPIID: id,
      });
    } else {
      this.setState({
        sendRevisedPIID: "",
        isRevisedPIGenerated: false,
      });
    }
    setTimeout(() => {
      console.log(this.state.sendRevisedPIID);
    }, 500);
  }
  toggleModal5(exhId, Status) {
    const { isOpen5 } = this.state;
    if (isOpen5 == true) {
      this.setState({
        isOpen5: false,
        RejectReason: "",
        SSIStatus: "",
        SSIexhID: "",
      });
    } else {
      this.setState({ isOpen5: true, SSIStatus: Status, SSIexhID: exhId });
    }
  }

  // Exhibitors Details Modal toggle
  toggleDetailModal() {
    const { isDetailOpen } = this.state;
    this.setState({ isDetailOpen: !isDetailOpen });
  }

  clearValue() {
    this.setState({
      exhibitor: "",
      exhibition: "",
      paymentTypeId: "",
      userName: "",
      statusID: "",
      exhibitorTypeId: "",
      boothTypeId: "",
      hallNumber: "",
      agentId: "",
      chapter: "",
      countryId: "",
      exhREgNo: "",
      stallNumber: "",
      fromArea: "",
      toArea: "",
      exhibitionID: "",
    });
    setTimeout(() => {
      this.getExhibitorList(null);
    }, 500);
  }

  // Toggle Send Credentials Log Modal
  toggleCredLogModal() {
    const { isOpenCredLog } = this.state;
    this.setState({ isOpenCredLog: !isOpenCredLog });
  }

  // Open Send Credentials Log Modal & fetch log data
  openCredLogModal() {
    this.setState({ isLoading: true });
    this.props
      .getExhSendCredLog_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            exhSendCredLogList:
              data.data != null && data.data.logList != null
                ? data.data.logList
                : [],
            credLogSearch: "",
            credLogCurrentPage: 1,
            isLoading: false,
            isOpenCredLog: true,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }

  // On Details Click
  onDetailsClick(e, exhregid) {
    this.setState({ isLoading: true });
    this.props
      .descriptionPreview_action(exhregid)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          console.log("ExhRegistration  Pdf Download", data);
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, "_blank");
          if (win != null) {
            win.focus();
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onBulkDetailsClick(e) {
    const { exhibitorList } = this.state;
    var tempexhibitorList = [];
    tempexhibitorList = exhibitorList.filter((item) => item.isSelect);
    console.log("tempexhibitorList", tempexhibitorList);
    var ExhList = [];
    tempexhibitorList.length > 0 &&
      tempexhibitorList.map((item) => {
        ExhList.push(item.ExhRegistrationID);
      });
    if (ExhList.length > 0) {
      this.setState({ isLoading: true });
      this.props
        .bulkDescriptionPreview_action(ExhList.toString())
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            console.log("ExhRegistration  Pdf Download", data);
            var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
            const win = window.location.replace(url, "_blank");
            if (win != null) {
              win.focus();
            }
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please select atleast 1 Exhibitor");
    }
  }

  // onSSIClick(e, exhregid) {
  //     this.setState({ isLoading: true })
  //     this.props.descriptionPreview_action(exhregid)
  //         .then((data) => {
  //             if (data.error != 1) {
  //                 this.setState({ isLoading: false })
  //                 console.log("ExhRegistration  Pdf Download", data)
  //                 var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
  //                 const win = window.location.replace(url, '_blank');
  //                 if (win != null) {
  //                     win.focus();
  //                 }
  //             }
  //             else {
  //                 this.setState({ isLoading: false })
  //                 toastError(data.msg)
  //             }
  //         })
  //         .catch((err) => {
  //             console.log(err)
  //         })
  // }

  // On Generate Click
  onGenerateClick(id, outstanding) {
    this.setState({ exhregId: id, exhibitorOutstanding: outstanding });
    this.getFillList(
      priorityNoActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    this.toggleModal();
  }

  // On Generate Hall No Stall No
  onGenerateHallNoStallNO(data) {
    this.setState({
      exhregId: data.ExhRegistrationID,
      modalArea: data.Area,
      modalOpenSide: data.OpenSides,
      modalData: data,
      StallpossessionScheduledDate: data.Scheme == "Bare Space" ? this.state.BareStartDate : this.state.ShellStartDate
    });
    this.toggleModal2();
  }

  // On Generate Priority No
  onFinalGeneratePriorityNo() {
    const { generatePriorityNoType } = this.state;
    if (generatePriorityNoType == 1) {
      this.generateAutoPriorityNo();
    } else {
      this.generateManualPriorityNo();
    }
  }

  // generate Manual priority No
  generateManualPriorityNo() {
    const { priorityNoId } = this.state;
    if (priorityNoId == "" || priorityNoId == "Select Priority Number") {
      this.setState({ priorityNoErr: "Please Select Priority No" });
    }
    setTimeout(() => {
      const { priorityNoErr, exhregId, isOpen, priorityNoId } = this.state;

      if (priorityNoId != "") {
        if (priorityNoErr == "") {
          this.setState({ isLoading: true });
          this.props
            .submitManualPriorityNo_action(priorityNoId, exhregId)
            .then((data) => {
              if (data.error != 1) {
                console.log("Manual Priority No ", data.data[0]["PriorityNo"]);
                this.setState({
                  isLoading: false,
                  exhregId: "",
                  exhibitorOutstanding: "",
                  isOpen: !isOpen,
                });
                this.getExhibitorList(null);
                toastSuccess(
                  `Generated Priority No:- ${data.data[0]["PriorityNo"]}`
                );
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }, 500);
  }

  // On Auto Generate Priority No
  generateAutoPriorityNo() {
    const { exhregId, isOpen } = this.state;
    this.setState({ isLoading: true });
    this.props
      .submitAutoPriorityNo_action(exhregId)
      .then((data) => {
        if (data.error != 1) {
          console.log("Auto Priority No ", data.data);
          this.setState({
            exhregId: "",
            exhibitorOutstanding: "",
            isOpen: !isOpen,
            isLoading: false,
          });
          toastSuccess(`Generated Priority No:- ${data.data[0]["PriorityNo"]}`);
          this.getExhibitorList(null);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Resend User ID & Password to exhibitors
  resendUserCred(e, exhregId, StatusID) {
    this.setState({ isLoading: true });
    this.props
      .sendUserCred_action(exhregId, 0, StatusID)
      .then((data) => {
        if (data.error != 1) {
          this.props.createExhSendCredLog_action(exhregId);
          this.setState({ isLoading: false });
          toastSuccess("UserID & Password Sent");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Resend User ID & Password to exhibitors
  sendhallstallUserCred(e, exhregId, hallStall) {
    hallStall = hallStall.split("/");
    this.props
      .sendhallstallUserCred_action(exhregId, hallStall[0], hallStall[1])
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("Hall/Stall number sent successfully");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Edit Click
  handleUpdate(data, flag) {
    sessionStorage.setItem("ExhibitorAccessData", JSON.stringify(data));
    this.props.navigate("/exhibitorspacebooking", { state: { isView: flag } });
  }

  // On Login Click
  onLogin(data) {
    var exhId = data.ExhibitionID;
    var id = data.UserName;
    // var pass = data.Password
    // var password = pass.replace('/', '§');
    // console.log("passContent", password)
    var loginContent = `${exhId}--${id}`;
    // --${password}`
    var url = `${loginUrl}${loginContent}`;
    console.log("url---------->", url);
    window.open(url, "_blank");
  }

  // Input Validation
  inputValidate() {
    const { hallNo, stallNo, StallpossessionScheduledDate } = this.state;
    if (hallNo == "") {
      this.setState({ hallNoErr: "Please Enter Hall No" });
    }
    if (stallNo == "") {
      this.setState({ stallNoErr: "Please Enter Stall No" });
    }
    if (StallpossessionScheduledDate == null) {
      this.setState({
        StallpossessionScheduledDateErr: "Please Select Scheduled Date",
      });
    }
  }

  // Input Validation
  inputValidate2() {
    const { openSide } = this.state;
    if (openSide == "") {
      this.setState({ openSideErr: "Please Enter Open Side." });
    }
  }

  // On Generate
  genrateHallStall() {
    this.inputValidate();
    const {
      isOpen2,
      hallNo,
      stallNo,
      hallNoErr,
      stallNoErr,
      exhregId,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, hallList, exhibitorList
    } = this.state;
    if (hallNo != "" && stallNo != "" && StallpossessionScheduledDate != null) {
      if (
        hallNoErr == "" &&
        stallNoErr == "" &&
        StallpossessionScheduledDateErr == ""
      ) {
        this.setState({ isLoading: true });
        this.props
          .generateHallNoStallNo_action(
            exhregId,
            hallNo,
            stallNo,
            moment(StallpossessionScheduledDate).format("yyyy-MM-DD")
          )
          .then((data) => {
            console.log("genrateHallStall Data", data.data);
            var tempList = [exhregId]
            if (data.error != 1) {
              this.props
                .getAPDetails_action(tempList.toString())
                .then((data) => {
                  if (data.error != 1) {
                    var tempAPlist = []
                    tempList.map(item => {
                      var obj = { ExhRegistrationID: item, hallList: [] }
                      exhibitorList.map(item2 => {
                        if (item2.ExhRegistrationID == item) {
                          obj.ExhibitorName = item2.ExhibitorName
                          obj.ExhRegistrationNo = item2.ExhRegistrationNo
                        }
                      })
                      hallList.map(item2 => {
                        obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: item, NonEmpanelVendorID: '', EmpanelVendorID: '', IsAccess: false })
                      })
                      if (data.data[0].length > 0) {
                        data.data[0].map(item2 => {
                          if (item == item2.ExhRegistrationID) {
                            hallList.map((item3, i) => {
                              if (item2.HallId == item3.HallId) {
                                obj.hallList[i].ExhibitionID = item2.ExhibitionID
                                obj.hallList[i].ExhregistrationID = item
                                obj.hallList[i].NonEmpanelVendorID = item2.NonEmpanelVendorID
                                obj.hallList[i].EmpanelVendorID = item2.EmpanelVendorID
                                obj.hallList[i].IsAccess = true
                              }
                            })
                          }
                        })
                      }
                      tempAPlist.push(obj)
                    })
                    var onlyVendorIds = []
                    if (data.data[1].length > 0) {
                      data.data[1].map(item2 => {
                        if (!onlyVendorIds.includes(item2.NonEmpanelVendorID)) {
                          onlyVendorIds.push(item2.NonEmpanelVendorID)
                        }
                      })
                    }
                    var tempVendorAPlist = []
                    onlyVendorIds.map(item => {
                      var obj = { NonEmpanelVendorID: item, hallList: [] }
                      data.data[1].map(item2 => {
                        exhibitorList.map(item3 => {
                          if (item3.ExhRegistrationID == item2.ExhRegistrationID) {
                            obj.ExhibitorName = item3.ExhibitorName
                            obj.ExhregistrationID = item3.ExhRegistrationID
                          }
                        })
                        if (item2.NonEmpanelVendorID == item) {
                          obj.CompanyName = item2.CompanyName
                        }
                      })
                      hallList.map(item2 => {
                        obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: '', NonEmpanelVendorID: item, EmpanelVendorID: '', IsAccess: false })
                      })
                      if (data.data[1].length > 0) {
                        data.data[1].map(item2 => {
                          if (item == item2.NonEmpanelVendorID) {
                            hallList.map((item3, i) => {
                              if (item2.HallId == item3.HallId) {
                                obj.hallList[i].ExhibitionID = item2.ExhibitionID
                                obj.hallList[i].ExhregistrationID = item2.ExhRegistrationID
                                obj.hallList[i].NonEmpanelVendorID = item
                                obj.hallList[i].EmpanelVendorID = item2.EmpanelVendorID
                                if (item2.HallId == hallNo) {
                                  obj.hallList[i].IsAccess = true
                                } else {
                                  obj.hallList[i].IsAccess = item2.AccessStatus == 'Yes' ? true : false
                                }
                              }
                            })
                          }
                        })
                      }
                      tempVendorAPlist.push(obj)
                    })

                    var finalList = []
                    tempAPlist.map(item => {
                      item.hallList.map(item2 => {
                        item2.IsAccess = true
                        finalList.push(item2)
                      })
                    })
                    tempVendorAPlist.map(item => {
                      item.hallList.map(item2 => {
                        finalList.push(item2)
                      })
                    })
                    this.setState({ isLoading: true });
                    this.props
                      .insertUpdateAP_action(finalList)
                      .then((data) => {
                        if (data.error != 1) {
                          // toastSuccess("Access control updated successfully")
                          this.setState({
                            isLoading: false,
                            exhregId: "",
                            isOpen2: !isOpen2,
                            // exhregId,
                            hallNo: '',
                            stallNo: '',
                            // moment().format("yyyy-MM-DD")
                            StallpossessionScheduledDate: null
                          });
                          toastSuccess(`Hall and Stall added successfully.`);
                          this.getExhibitorList(null);
                          this.setState({ isLoading: false, isOpenAc: false });
                        }
                      }).catch((err) => {
                        console.log(err);
                      });
                    // toastSuccess("Generated Successful
                    // this.setState({ accessControlList: tempAPlist, accessControlVendorList: tempVendorAPlist, isOpenAc: true })
                    // this.getExhibitorList();
                    this.setState({ isLoading: false });
                  } else {
                    toastError(data.error)
                    this.setState({ isLoading: false });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });



            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          });
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  // On Hall No Stall No
  onHallStallClick(data, id) {
    this.getFillList(stallNoListActionId, "", data.HallId, "", "", id);
    this.setState({
      hallNo: data.HallId,
      stallNo: data.StallId,
      exhregId: id,
      modalArea: data.Area,
      modalOpenSide: data.OpenSides,
      modalData: data,
      StallpossessionScheduledDate: data.StallpossessionScheduledDate
        ? moment(data.StallpossessionScheduledDate, "YYYY-MM-DD").toDate()
        : null,
    });
    console.log(data.Area, data.OpenSides);
    this.toggleModal2();
  }

  // On open side click.......
  onOpenSideClick(number, id) {
    this.setState({ openSide: number, exhregId: id });
    this.toggleModal3();
  }

  // On Area Click
  onAreaClick(
    ExhibitionStallSizeID,
    StallDimension,
    StallTypeID,
    area,
    id,
    CountryID,
    areaExhibitionID
  ) {
    this.setState({
      stallAreaId: ExhibitionStallSizeID,
      exhregId: id,
      areaExhibitionID: areaExhibitionID,
      areaCountryID: CountryID,
      stallAreaName: StallDimension,
      schemeType: StallTypeID,
      stallArea: area,
    });
    this.getFillList(
      stallSizeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      StallTypeID,
      CountryID,
      ""
    );
    this.setState({ isLoading: false });
    this.toggleModal4();
  }

  onLengthTypeChange(e) {
    this.setState({ stallAreaId: e.target.value });
    console.log(e.target.value);
    const { stallAreaList, stallAreaName } = this.state;
    for (var i = 0; i < stallAreaList.length; i++) {
      if (stallAreaList[i].Code == e.target.value) {
        console.log("Description : ", stallAreaList[i].Description);
        this.setState({
          stallAreaName: stallAreaList[i].Description,
          stallArea: stallAreaList[i].StallArea,
        });
      }
    }
  }

  // On Generate
  onUpdateStallTypeArea() {
    const {
      isOpen3,
      isOpen4,
      openSide,
      areaExhibitionID,
      openSideErr,
      exhregId,
      stallArea,
      stallAreaId,
      stallAreaName,
      schemeType,
    } = this.state;
    if (
      exhregId != "" &&
      stallAreaId != "" &&
      stallArea != "" &&
      schemeType != "" &&
      stallAreaName != "" &&
      areaExhibitionID != ""
    ) {
      this.setState({ isLoading: true });
      this.props
        .updateStallTypeArea_action(
          areaExhibitionID,
          exhregId,
          stallAreaId,
          stallArea,
          schemeType,
          stallAreaName
        )
        .then((data) => {
          console.log("genrate open side Data", data.data);
          if (data.error != 1) {
            this.setState({
              isLoading: false,
              // exhregId: "",
              stallAreaId: "",
              stallArea: "",
              schemeType: "",
              stallAreaName: "",
              isOpen4: !isOpen4,
            });
            toastSuccess(`Area Updated successfully.`);
            this.getExhibitorList(null);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        });
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  // On Generate
  ChangeOpenSide() {
    this.inputValidate2();
    const { isOpen3, openSide, openSideErr, exhregId } = this.state;
    if (openSide != "") {
      if (openSideErr == "") {
        this.setState({ isLoading: true });
        this.props.generateOpenSide_action(exhregId, openSide).then((data) => {
          console.log("genrate open side Data", data.data);
          if (data.error != 1) {
            this.setState({
              isLoading: false,
              // exhregId: "",
              isOpen3: !isOpen3,
            });
            toastSuccess(`Open Side Updated successfully.`);
            this.getExhibitorList(null);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        });
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  //on Select All Click
  selectAllExhibitors(e) {
    const { checkedAll, exhibitorList } = this.state;
    // this.setState({ checkedAll: !checkedAll })
    // const checked = e.target.checked
    // exhibitorList.length > 0 && exhibitorList.map((data) => {
    //     if (checked) {
    //         if (data.StatusID != '1' && data.StatusID != '2') {
    //             data.isSelect = true
    //         }
    //     } else {
    //         data.isSelect = false
    //     }
    // })
    // console.log("yyyyyyyyyyyyy", exhibitorList)

    if (checkedAll) {
      exhibitorList.map((data) => {
        data.isSelect = false;
      });
      this.setState({ checkedAll: false, exhibitorList: exhibitorList });
    } else {
      exhibitorList.map((data) => {
        data.isSelect = true;
      });
      this.setState({ checkedAll: true, exhibitorList: exhibitorList });
    }
  }

  // On Checked exhibitors
  handleCheckedExhibitors(e, id) {
    const { exhibitorList } = this.state;
    const checked = e.target.checked;

    exhibitorList.length > 0 &&
      exhibitorList.map((data) => {
        if (data.ExhRegistrationID == id) {
          if (checked) {
            data.isSelect = true;
          } else {
            data.isSelect = false;
          }
        }
      });
    console.log("aaaaaaaaaaa", exhibitorList);
    this.setState({ exhibitorList: exhibitorList }, () => {
      // setTimeout(() => {
      const allSelected = exhibitorList.every((item) => item.isSelect == true);

      if (allSelected) {
        this.setState({ checkedAll: true });
      } else {
        this.setState({ checkedAll: false });
      }
      // }, 100);
    });
  }

  // On Download Manual Form Report
  onDownloadManualFormReport = async () => {
    const { exhibitorList } = this.state;
    try {
      var selectedExhibitors = exhibitorList.filter((item) => item.isSelect);
      if (selectedExhibitors.length > 0) {
        this.setState({ isLoading: true });
        var exhIdList = [];

        selectedExhibitors.length > 0 &&
          selectedExhibitors.map((data, index) => {
            exhIdList.push(data.ExhRegistrationID);
          });
        var list = [];
        const mapdata1 = {
          ParameterName: "@UserID",
          ParameterValue: JSON.parse(sessionStorage.getItem("loginDataSS"))
            .UserID,
          ParameterDataType: "int",
        };
        list.push(mapdata1);
        const mapdata2 = {
          ParameterName: "@ExhibitionID",
          ParameterValue: parseInt(
            sessionStorage.getItem("sessionExhibitionID")
          ),
          ParameterDataType: "int",
        };
        list.push(mapdata2);
        const mapdata3 = {
          ParameterName: "@ExhRegistration",
          ParameterValue: exhIdList.toString(),
          ParameterDataType: "varchar",
        };
        list.push(mapdata3);
        const mapData = {
          report_name: manualFormDoc,
          parameter_details: list,
        };
        console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);

        const res = await axiosPost(fetchAuthReport, mapData);
        this.setState({ isLoading: false });

        if (res != null) {
          var url = `${downloadReport}?SessionIdentifier=${res}&Export=Yes`;
          const win = window.location.replace(url, "_blank");
          if (win != null) {
            win.focus();
          }
        }
      } else {
        toastError("Please select Atleast One Exhibitor");
      }
    } catch (err) {
      console.error(err);
    }
  };

  // On Add Edirectory
  onAddEdirectory() {
    const { exhibitorList } = this.state;
    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    if (selectedExhibitors.length > 0) {
      var list = [];
      selectedExhibitors.length > 0 &&
        selectedExhibitors.map((element) => {
          var mapdata = {
            ExhregistrationID: element.ExhRegistrationID,
          };
          list.push(mapdata);
        });
      this.setState({ isLoading: true });
      this.props
        .addEdirectoryManual_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess("E-Directory Added Successfully");
            this.getExhibitorList(null);
          } else {
            this.setState({ isLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please Select Atleast one exhibitor");
    }
  }

  // On Add Edirectory
  removedEdirectoryManual() {
    const { exhibitorList } = this.state;
    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    if (selectedExhibitors.length > 0) {
      var list = [];
      selectedExhibitors.length > 0 &&
        selectedExhibitors.map((element) => {
          var mapdata = {
            ExhregistrationID: element.ExhRegistrationID,
          };
          list.push(mapdata);
        });
      this.setState({ isLoading: true });
      this.props
        .removedEdirectoryManual_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess("E-Directory Added Successfully");
            this.getExhibitorList(null);
          } else {
            this.setState({ isLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please Select Atleast one exhibitor");
    }
  }

  sendRevisedPI() {
    const { exhibitorList, sendRevisedPIID } = this.state;
    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    var list = [];
    if (sendRevisedPIID != "" && sendRevisedPIID != null) {
      var mapdata = {
        ExhregistrationID: sendRevisedPIID,
      };
      list.push(mapdata);
    }
    if (list.length > 0) {
      this.setState({ isLoading: true });
      this.props
        .sendRevisedPI_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({
              isLoading: false,
              isOpen8: false,
              isRevisedPIGenerated: false,
            });
            toastSuccess("Mail Sent Successfully");
            this.getExhibitorList(null);
          } else {
            this.setState({
              isLoading: false,
              isOpen8: false,
              isRevisedPIGenerated: false,
            });
            toastError("something went wrong...");
            this.getExhibitorList(null);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("something went wrong...");
    }
  }

  generateRevisedPI() {
    const { exhibitorList, sendRevisedPIID } = this.state;
    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    var list = [];
    if (sendRevisedPIID != "" && sendRevisedPIID != null) {
      var mapdata = {
        ExhregistrationID: sendRevisedPIID,
      };
      list.push(mapdata);
    }
    if (list.length > 0) {
      this.setState({ isLoading: true });
      this.props
        .generateRevisedPI_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false, isRevisedPIGenerated: true });
            toastSuccess("Generated Successfully");
          } else {
            this.setState({ isLoading: false });
            toastError("something went wrong...");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("something went wrong...");
    }
  }

  removeHallStall() {
    const { exhibitorList, exhregId } = this.state;
    this.setState({ isLoading: true });
    this.props
      .removeHallStall_action(exhregId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          this.setState({ removeHallStallPop: false })
          toastSuccess("Removed Successfully");
          this.toggleModal2()
          this.getExhibitorList(null);
        } else {
          this.setState({ isLoading: false });
          toastError("something went wrong...");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Details Click
  onViewRevisedPIClick(e) {
    const { exhibitorList, sendRevisedPIID } = this.state;
    this.setState({ isLoading: true });
    var countryId = "";
    for (var i = 0; i < exhibitorList.length; i++) {
      if (exhibitorList[i].ExhRegistrationID == sendRevisedPIID) {
        countryId = exhibitorList[i].CountryID;
      }
    }
    this.props
      .viewRevisedPI_action(countryId, sendRevisedPIID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          // var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          // const win = window.location.replace(url, '_blank');
          // if (win != null) {
          //     win.focus();
          // }
          if (data != null) {
            var url = `${downloadReport}?SessionIdentifier=${data}`;
            const win = window.open(url, "_blank", "noopener,noreferrer");
            if (win != null) {
              win.focus();
            }
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Add Fascia
  onAddFascia() {
    const { exhibitorList } = this.state;
    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    if (selectedExhibitors.length > 0) {
      var list = [];
      selectedExhibitors.length > 0 &&
        selectedExhibitors.map((element) => {
          var mapdata = {
            ExhregistrationID: element.ExhRegistrationID,
          };
          list.push(mapdata);
        });
      this.setState({ isLoading: true });
      this.props
        .addFasciaManual_action(list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess("Fascia Added Successfully");
            this.getExhibitorList();
          } else {
            this.setState({ isLoading: false });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please Select Atleast one exhibitor");
    }
  }

  getWriteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.WriteAccess;
    } else {
      return false
    }
    return false;
  }

  getReadAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.ReadAccess;
    } else {
      return false
    }
    return false;
  }

  getUpdateAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.UpdateAccess;
    } else {
      return false
    }
    return false;
  }

  getDeleteAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.DeleteAccess;
    } else {
      return false
    }
    return false;
  }

  getStatusIdByName(statusName) {
    const statusNameLower = statusName.toLowerCase();
    const statusMap = {
      "received": 1,
      "incomplete": 2,
      "complete": 3,
      "activated": 4,
      "duplicate": 5,
      "cancelled": 6,
      "waitlisted": 7
    };
    return statusMap[statusNameLower] || null;
  }

  getDownloadAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.DownloadAccess;
    } else {
      return false
    }
    return false;
  }

  getSendAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.SendAccess;
    } else {
      return false
    }
    return false;
  }


  getSpecialAccess() {
    const { loginAccesslist } = this.state
    const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '9' || item.ModuleID == '41');
    if (moduleAccess) {
      return moduleAccess.Is_SpecialAccess;
    } else {
      return false
    }
    return false;
  }

  activateDeactivateUsers(isActivated) {
    const { exhibitorList } = this.state;

    var selectedExhibitors =
      exhibitorList.length > 0 && exhibitorList.filter((item) => item.isSelect);
    if (selectedExhibitors.length > 0) {
      var list = [];
      selectedExhibitors.length > 0 &&
        selectedExhibitors.map((element) => {
          var mapdata = {
            ExhregistrationID: element.ExhRegistrationID,
            StatusID: element.StatusID,
          };
          list.push(mapdata);
        });
      this.setState({ isLoading: true });
      this.props
        .activateDeactivateExhibitors_action(isActivated, list)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess("Exhibitor Record Updated");
            this.getExhibitorList();
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please Select Atleast one exhibitor");
    }
  }

  onHallChange(e, flag) {
    var value = e.target.value;
    this.getFillList(stallNoListActionId, "", value, "", "", this.state.exhregId);
    if (flag == 1) {
      this.getFillList(segmentActionId, "", value, "", "", "");
    }
    this.setState({ hallNo: value, hallNoErr: "", isLoading: false });
    if (value == '') {
      this.setState({ stallNo: '' });
    }
  }

  onDiscountClick(data, exhId) {
    const { isOpen6, discountExhibitonID } = this.state;
    if (isOpen6) {
      this.setState({
        discountPercent: "",
        discountExhibitonID: "",
        discountErr: "",
        exhregId: "",
        isOpen6: false,
      });
    } else if (!isOpen6) {
      if (data.discount != null && data.discount != "") {
        this.setState({ discountPercent: data.discount });
      } else if (data.DiscountAmount != null && data.DiscountAmount != "") {
        this.setState({ discountAmt: data.DiscountAmount });
      }
      this.setState({
        isOpen6: true,
        exhregId: exhId,
        discountErr: "",
        discountExhibitonID: data.ExhibitionID,
      });
    }
  }
  onGenerateOpenSidePI(data, exhId) {
    const { isOpen7, openSidePIExhibitionID } = this.state;
    if (isOpen7) {
      this.setState({
        openSidePIExhibitionID: "",
        exhregId: "",
        isOpen7: false,
      });
    } else if (!isOpen7) {
      this.setState({
        isOpen7: true,
        exhregId: exhId,
        openSidePIExhibitionID: data.ExhibitionID,
      });
    }
  }

  onDiscountSubmit() {
    const {
      discountPercent,
      exhregId,
      discountExhibitonID,
      discountAmt,
      discountErr,
    } = this.state;
    if (discountPercent == "" && discountAmt == "") {
      toastError("Please enter Discount Value");
    } else {
      if (discountPercent != "" && discountAmt != "") {
        toastError("Please enter Discount Percent OR Discount Amount");
        this.setState({
          discountErr: "Please enter Discount Percent OR Discount Amount",
        });
      } else {
        if (discountErr == null || discountErr == "") {
          console.log(discountExhibitonID, exhregId, discountPercent);
          this.setState({ isLoading: true });
          this.props
            .submitDiscount_action(
              discountExhibitonID,
              exhregId,
              parseInt(discountPercent),
              discountAmt == "" ? null : discountAmt
            )
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false });
                toastSuccess("Discount given Successfully");
                this.setState({
                  discountPercent: "",
                  discountExhibitonID: "",
                  discountErr: "",
                  exhregId: "",
                  isOpen6: false,
                });
                this.getExhibitorList();
              } else {
                this.setState({ isLoading: false });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toastError("Please enter Proper Discount Value");
        }
      }
    }
  }
  onDiscountChange(e, mode) {
    const { discountPercent } = this.state;
    // console.log(e.target)
    if (mode == 0) {
      this.setState({ discountPercent: e.target.value });
      var err = false;
      for (var i = 0; i < e.target.value.length; i++) {
        if (
          e.target.value[i] == "e" ||
          e.target.value[i] == "." ||
          e.target.value[i] == "-"
        ) {
          err = "discount percent needs to be an integer";
        }
        if (e.target.value > 100) {
          err = "discount percent should be less than 100";
        }
      }
      if (err != false) {
        this.setState({ discountErr: err });
      } else {
        this.setState({ discountErr: "" });
      }
    } else {
      this.setState({ discountAmt: e.target.value });
      var err = false;
      for (var i = 0; i < e.target.value.length; i++) {
        if (e.target.value[i] == "e" || e.target.value[i] == "-") {
          err = "discount percent needs to be an integer";
        }
      }
      if (err != false) {
        this.setState({ discountErr: err });
      } else {
        this.setState({ discountErr: "" });
      }
    }
  }
  onPISubmit() {
    const { exhregId, openSidePIExhibitionID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .submitOpenSidePI_action(openSidePIExhibitionID, exhregId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("Generated Successfully");
          this.setState({
            openSidePIExhibitionID: "",
            exhregId: "",
            isOpen7: false,
          });
          this.getExhibitorList();
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onOpenAccessControlModal(mode, exhid) {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr,
    } = this.state;
    var tempList = []
    if (mode == 0) {
      tempList.push(exhid)
    } else {
      exhibitorList.length > 0 && exhibitorList.map(item => {
        if (item.isSelect) {
          tempList.push(item.ExhRegistrationID)
        }
      })
    }
    this.props
      .getAPDetails_action(tempList.toString())
      .then((data) => {
        if (data.error != 1) {
          var tempAPlist = []
          tempList.map(item => {
            var obj = { ExhRegistrationID: item, hallList: [] }
            exhibitorList.map(item2 => {
              if (item2.ExhRegistrationID == item) {
                obj.ExhibitorName = item2.ExhibitorName
                obj.ExhRegistrationNo = item2.ExhRegistrationNo
              }
            })
            hallList.map(item2 => {
              obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: item, NonEmpanelVendorID: '', EmpanelVendorID: '', IsAccess: false })
            })
            if (data.data[0].length > 0) {
              console.log(1, 'ccc', data.data[0])
              data.data[0].map(item2 => {
                console.log(2, 'ccc', item2)
                if (item == item2.ExhRegistrationID) {
                  console.log(3, 'ccc', item2, hallList)
                  hallList.map((item3, i) => {
                    if (item2.HallId == item3.HallId) {
                      console.log(3, 'ccc', item2, item3, hallList, obj.hallList[i])
                      obj.hallList[i].ExhibitionID = item2.ExhibitionID
                      obj.hallList[i].ExhregistrationID = item
                      obj.hallList[i].NonEmpanelVendorID = item2.NonEmpanelVendorID
                      obj.hallList[i].EmpanelVendorID = item2.EmpanelVendorID
                      obj.hallList[i].IsAccess = item2.AccessStatus == 'Yes'
                    }
                  })
                }
              })
            }
            tempAPlist.push(obj)
          })
          var onlyVendorIds = []
          if (data.data[1].length > 0) {
            data.data[1].map(item2 => {
              if (!onlyVendorIds.includes(item2.NonEmpanelVendorID)) {
                onlyVendorIds.push(item2.NonEmpanelVendorID)
              }
            })
          }
          var tempVendorAPlist = []
          onlyVendorIds.map(item => {
            var obj = { NonEmpanelVendorID: item, hallList: [] }
            data.data[1].map(item2 => {
              exhibitorList.map(item3 => {
                if (item3.ExhRegistrationID == item2.ExhRegistrationID) {
                  obj.ExhibitorName = item3.ExhibitorName
                  obj.ExhregistrationID = item3.ExhRegistrationID
                }
              })
              if (item2.NonEmpanelVendorID == item) {
                obj.CompanyName = item2.CompanyName
              }
            })
            hallList.map(item2 => {
              obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: '', NonEmpanelVendorID: item, EmpanelVendorID: '', IsAccess: false })
            })
            if (data.data[1].length > 0) {
              data.data[1].map(item2 => {
                if (item == item2.NonEmpanelVendorID) {
                  hallList.map((item3, i) => {
                    if (item2.HallId == item3.HallId) {
                      obj.hallList[i].ExhibitionID = item2.ExhibitionID
                      obj.hallList[i].ExhregistrationID = item2.ExhRegistrationID
                      obj.hallList[i].NonEmpanelVendorID = item
                      obj.hallList[i].EmpanelVendorID = item2.EmpanelVendorID
                      obj.hallList[i].IsAccess = item2.AccessStatus == 'Yes'
                    }
                  })
                }
              })
            }
            tempVendorAPlist.push(obj)
          })
          setTimeout(() => {

            console.log("tempAPlisttempAPlist", tempAPlist, tempList)
          }, 1000);
          // toastSuccess("Generated Successful
          this.setState({ accessControlList: tempAPlist, accessControlVendorList: tempVendorAPlist, isOpenAc: true })
          // this.getExhibitorList();
          this.setState({ isLoading: false });
        } else {
          toastError(data.error)
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  onAPClick(exhid, hallid) {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, accessControlList,
    } = this.state;
    accessControlList.length > 0 && accessControlList.map(item => {
      if (item.ExhRegistrationID == exhid) {
        item.hallList.map(item2 => {
          if (item2.HallId == hallid) {
            if (item2.IsAccess) {
              item2.IsAccess = false
            } else {
              item2.IsAccess = true
            }
          }
        })
      }
    })
    this.setState({ accessControlList: accessControlList })
  }

  onVendorAPClick(venid, hallid) {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, accessControlList, accessControlVendorList,
    } = this.state;
    accessControlVendorList.length > 0 && accessControlVendorList.map(item => {
      if (item.NonEmpanelVendorID == venid) {
        item.hallList.map(item2 => {
          if (item2.HallId == hallid) {
            if (item2.IsAccess) {
              item2.IsAccess = false
            } else {
              item2.IsAccess = true
            }
          }
        })
      }
    })
    this.setState({ accessControlVendorList: accessControlVendorList })
  }

  insertUpdateAP() {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, accessControlList, accessControlVendorList
    } = this.state;
    var finalList = []
    accessControlList.map(item => {
      item.hallList.map(item2 => {
        finalList.push(item2)
      })
    })
    accessControlVendorList.map(item => {
      item.hallList.map(item2 => {
        finalList.push(item2)
      })
    })
    this.setState({ isLoading: true });
    this.props
      .insertUpdateAP_action(finalList)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Access control updated successfully")
          this.setState({ isLoading: false, isOpenAc: false });
        }
      }).catch((err) => {
        console.log(err);
      });
  }

  render() {
    const {
      isLoading,
      isRevisedPIGenerated,
      proformaInv, areasList, accessControlList, accessControlVendorList,
      exhSendCredLogList,
      credLogSearch,
      credLogCurrentPage,
      exhibitor,
      proformaDate,
      proformaNo,
      currentPage,
      isOpen,
      isDetailOpen,
      exhibition,
      exhibitorList,
      estimateDetails,
      generatePriorityNoType,
      priorityNoList,
      priorityNoId,
      priorityNoErr,
      exhibitorOutstanding,
      isOpen2,
      isOpen3,
      hallNo,
      openSide,
      stallNo,
      hallNoErr,
      stallNoErr,
      openSideErr,
      checkedAll,
      paymentTypeList,
      paymentTypeId,
      statusCount,
      userName,
      statusID,
      statusTypeList,
      exhibitorTypeId,
      exhibitorTypeList,
      boothTypeId,
      boothTypeList,
      hallNoList,
      hallNumber,
      agentList,
      agentId,
      chapterList,
      chapter,
      countryId,
      countryList,
      exhREgNo,
      schemeTypeList,
      schemeType,
      stallNumber,
      fromArea,
      toArea,
      isFromDashboard,
      hallList,
      stallList,
      isOpen4,
      showForRegistration,
      isOpen8,
      startIndex,
      stallAreaId,
      exhRegList,
      stallAreaList,
      stallAreaName,
      modalData,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = exhibitorList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(exhibitorList.length / recordsPerPage);
    console.log(hallList, hallNo, stallNo,
      "exhibitorListexhibitorList",
      exhibitorList.length,
      exhRegList.length, accessControlList, accessControlVendorList
    );
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <div className="row m-0">
          <div className="breadcrumb-scroll-fixed with-dr-container">
            <h6 className="mb-0 px-2 py-2 text-white">Exhibitor List</h6>
          </div>
        </div>
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container admin-top-space"
              : "with-dr-container com-height"
          }
        >
          <div className="main-container admin-top-space">
            <AdminDrawer />
          </div>
          {!isFromDashboard && (
            <div className="row mx-3 mt-1 mb-2 m-0 text-center p-0">
              {statusCount.length > 0 &&
                statusCount.map((data) => {
                  const statusId = this.getStatusIdByName(data.Name);
                  return (
                    <div
                      className="col top-box mt-3"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => this.getExhibitorList(statusId)}
                    >
                      <p className="text-center mb-0 pb-2">
                        {data.Name.toUpperCase()}
                      </p>
                      <h4 className="mb-0 pb-1">{data.Count}</h4>
                    </div>
                  );
                })}
            </div>
          )}

          <div className="main-container p-2 mt-1">
            {!isFromDashboard && (
              <div className="row m-0">
                <div className="col-xl-3 mb-3">
                  <label>Exhibitor</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={exhibitor}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) =>
                      this.setState({ exhibitor: e.target.value })
                    }
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Exhibition</label>
                  <select
                    className="form-control"
                    value={this.state.exhibitionID}
                    onChange={(e) =>
                      this.setState({ exhibitionID: e.target.value })
                    }
                  >
                    <option value={""}>Select Exhibition</option>
                    {this.state.exhibitionList.length > 0 &&
                      this.state.exhibitionList.map((data) => (
                        <option
                          key={data.ExhibitionID}
                          value={data.ExhibitionID}
                        >
                          {data.ExhibitionName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Payment Type</label>
                  <select
                    className="form-control"
                    value={paymentTypeId}
                    onChange={(e) =>
                      this.setState({ paymentTypeId: e.target.value })
                    }
                  >
                    <option value={""}>Select Payment Type</option>
                    {paymentTypeList.length > 0 &&
                      paymentTypeList.map((data) => (
                        <option key={data.ID} value={data.ID}>
                          {data.PaymentType}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label>User Name</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={userName}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) =>
                      this.setState({ userName: e.target.value })
                    }
                  />
                </div>
              </div>
            )}
            {!isFromDashboard && (
              <div className="row m-0">
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Status</label>
                  <select
                    className="form-control"
                    value={statusID}
                    onChange={(e) =>
                      this.setState({ statusID: e.target.value })
                    }
                  >
                    <option value={""}>Select Status</option>
                    {statusTypeList.length > 0 &&
                      statusTypeList.map((data) => (
                        <option key={data.ID} value={data.ID}>
                          {data.Name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Exhibitor Type</label>
                  <select
                    className="form-control"
                    value={exhibitorTypeId}
                    onChange={(e) =>
                      this.setState({ exhibitorTypeId: e.target.value })
                    }
                  >
                    <option value={""}>Select Exhibitor Type</option>
                    {exhibitorTypeList.length > 0 &&
                      exhibitorTypeList.map((data) => (
                        <option key={data.ID} value={data.ID}>
                          {data.ExhibitorType}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Booth Type</label>
                  <select
                    className="form-control"
                    value={boothTypeId}
                    onChange={(e) =>
                      this.setState({ boothTypeId: e.target.value })
                    }
                  >
                    <option value={""}>Select Booth Type</option>
                    {boothTypeList.length > 0 &&
                      boothTypeList.map((data) => (
                        <option key={data.Code} value={data.Code}>
                          {data.Description}
                        </option>
                      ))}
                  </select>
                </div>
                {/* <div className="col-xl-3 mb-3">
                            <label htmlFor="validationCustom03">Booking Status</label>
                            <select className="form-control"
                            value={exhibitorTypeId}
                            onChange={(e) => this.setState({ exhibitorTypeId: e.target.value })}
                            >
                                <option>Select Booking Status</option>
                                {
                                    exhibitorTypeList.length > 0 && exhibitorTypeList.map((data) => (
                                        <option key={data.ID} value={data.ID}>{data.ExhibitorType}</option>
                                    ))
                                }
                            </select>
                        </div> */}
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Hall NO</label>
                  <select
                    className="form-control"
                    value={hallNumber}
                    onChange={(e) =>
                      this.setState({ hallNumber: e.target.value })
                    }
                  >
                    <option value={""}>Select Hall NO</option>
                    {this.state.hallMasterList.length > 0 &&
                      this.state.hallMasterList.map((data) => (
                        <option key={data.HallId} value={data.HallId}>
                          {data.HallName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            )}
            {!isFromDashboard && (
              <div className="row m-0">
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Agent List</label>
                  <select
                    className="form-control"
                    value={agentId}
                    onChange={(e) => this.setState({ agentId: e.target.value })}
                  >
                    <option value={""}>Select Agent</option>
                    {agentList.length > 0 &&
                      agentList.map((data) => (
                        <option key={data.AccountID} value={data.AccountID}>
                          {data.CompanyName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Primary Chapter</label>
                  <select
                    className="form-control"
                    value={chapter}
                    onChange={(e) => this.setState({ chapter: e.target.value })}
                  >
                    <option value={""}>Select Primary Chapter</option>
                    {chapterList.length > 0 &&
                      chapterList.map((data) => (
                        <option
                          key={data.PrimaryChapter}
                          value={data.PrimaryChapter}
                        >
                          {data.PrimaryChapter}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label htmlFor="validationCustom03">Country</label>
                  <select
                    className="form-control"
                    value={countryId}
                    onChange={(e) =>
                      this.setState({ countryId: e.target.value })
                    }
                  >
                    <option value={""}>Select Country</option>
                    {countryList.length > 0 &&
                      countryList.map((data) => (
                        <option key={data.Code} value={data.Code}>
                          {data.Description}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-xl-3 mb-3">
                  <label>Application No</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={exhREgNo}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) =>
                      this.setState({ exhREgNo: e.target.value })
                    }
                  />
                </div>
              </div>
            )}
            {!isFromDashboard && (
              <div className="row m-0">
                <div className="col-xl-3 mb-3">
                  <label>Stall No</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={stallNumber}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) =>
                      this.setState({ stallNumber: e.target.value })
                    }
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label>From Area</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={fromArea}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) =>
                      this.setState({ fromArea: e.target.value })
                    }
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label>To Area</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue=""
                    required=""
                    value={toArea}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onChange={(e) => this.setState({ toArea: e.target.value })}
                  />
                </div>
                <div className="col-xl-3 mb-3">
                  <label></label>
                  <button
                    type="button"
                    className="btn btn-aqua mt-1"
                    onClick={(e) => this.onSearchClick()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray mt-1 ms-2"
                    onClick={(e) => this.clearValue()}
                  >
                    Clear
                  </button>
                  {/* <i
                    className="fa fa-info-circle mt-1 ms-2"
                    title="Send Credentials Log"
                    style={{
                      fontSize: "22px",
                      color: "#22b2a5",
                      cursor: "pointer",
                      verticalAlign: "middle",
                    }}
                    onClick={(e) => this.openCredLogModal()}
                  ></i> */}
                </div>
              </div>
            )}
            <div className="row m-0">
              <div className="col-md-12">
                {!isFromDashboard && (
                  <>
                    <div
                      className="mb-1"
                      role="group"
                      aria-label="Basic example"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-aqua"
                        disabled={!this.getDownloadAccess()}
                        onClick={(e) => this.onDownloadManualFormReport()}
                      >
                        Manual Form Report
                      </button>
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
                      />
                      <button
                        type="button"
                        className="btn btn-aqua d-flex"
                        disabled={!this.getWriteAccess()}
                        onClick={(e) => this.onAddEdirectory()}
                      >
                        <span class="material-symbols-outlined me-1" style={{ fontSize: '16px' }}>add</span>{" "}
                        E-Directory
                      </button>
                      <button
                        type="button"
                        className="btn btn-aqua d-flex"
                        disabled={!this.getWriteAccess()}
                        onClick={(e) => this.removedEdirectoryManual()}
                      >
                        <span class="material-symbols-outlined me-1" style={{ fontSize: '16px' }}>
                          close
                        </span>{" "}
                        E-Directory
                      </button>
                      <button
                        type="button"
                        className="btn btn-aqua d-flex"
                        disabled={!this.getWriteAccess()}
                        onClick={(e) => this.onAddFascia()}
                      >
                        <span className="material-symbols-outlined me-1" style={{ fontSize: '16px' }}>
                          add
                        </span>
                        Fascia
                      </button>
                      <button
                        type="button"
                        className="btn btn-aqua"
                        disabled={!this.getSpecialAccess()}
                        onClick={(e) => this.onOpenAccessControlModal()}
                      >
                        Access Control
                      </button>
                      <button
                        type="button"
                        className="btn btn-aqua"
                        disabled={!this.getSpecialAccess()}
                        onClick={(e) => this.activateDeactivateUsers(1)}
                      >
                        Activate
                      </button>
                      <button
                        type="button"
                        className="btn btn-red"
                        disabled={!this.getSpecialAccess()}
                        onClick={(e) => this.activateDeactivateUsers(0)}
                      >
                        Deactivate
                      </button>
                      {this.onExportToExcel()}
                      {this.onCreateExcel()}
                      <span
                        disabled={!this.getDownloadAccess()}
                        onClick={(e) => this.onBulkDetailsClick(e)}
                        title="Bulk Registration Document Download"
                      >
                        <i className="fa fa-id-card-o rounded-2 export-icon"></i>
                      </span>
                    </div>
                  </>
                )}

                <div className="table-responsive">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        <th className="text-center" style={{ width: 60 }}>
                          <input type="checkbox"
                            checked={checkedAll}
                            onChange={(e) => this.selectAllExhibitors(e)}
                          />
                        </th>
                        <th className="text-center" style={{ width: 50 }}>
                          Sr.No
                        </th>
                        <th>Exhibition</th>
                        <th>Registration Date</th>
                        <th>Agent</th>
                        <th>Application No.</th>
                        <th>Exhibitor</th>
                        <th>Country</th>
                        <th>Chapters</th>
                        <th className="text-center" style={{ width: 100 }}>
                          Area (sqm)
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Stall Dimension
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Open Side
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Hall/Stall
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          open side PI
                        </th>
                        <th>Scheme</th>
                        <th className="text-center" style={{ width: 100 }}>
                          Discount
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Info
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          SSI/TMMA-ITAMMA certificate
                        </th>
                        {(this.getWriteAccess() || JSON.parse(sessionStorage.getItem("loginDataSS")).UserID == 233) &&
                          <th className="text-center" style={{ width: 100 }}>
                            HallNo/StallNo
                          </th>
                        }
                        {/* <th className="text-center" style={{ width: 100 }}>
                                                    Priority No
                                                </th> */}
                        <th className="text-center" style={{ width: 100 }}>
                          First Rank
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Second Rank
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Final Rank
                        </th>
                        <th className="text-center" style={{ width: 100 }}>
                          Priority No
                        </th>
                        {/* {this.getUpdateAccess() && */}
                        {<th>View Application</th>}
                        {/* } */}
                        {this.getSpecialAccess() &&
                          <th></th>
                        }
                        <th></th>
                        {this.getSpecialAccess() &&
                          <th></th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.length > 0 ? (
                        currentRecords.map((data, index) => (
                          <tr key={Math.random()}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                // disabled={data.StatusID == '1' || data.StatusID == '2'}
                                value={data.isSelect}
                                checked={data.isSelect}
                                onChange={(e) =>
                                  this.handleCheckedExhibitors(
                                    e,
                                    data.ExhRegistrationID
                                  )
                                }
                              />
                            </td>
                            <td className="text-center">
                              {this.state.startIndex + index + 1}
                            </td>
                            <td>{data.ExhibitionName}</td>
                            <td>
                              {data.ExhRegistrationDate != null
                                ? moment(data.ExhRegistrationDate).format(
                                  "DD/MM/YYYY"
                                )
                                : null}
                            </td>
                            <td>{data.AgentCompanyName != null ? data.AgentCompanyName : ''}</td>
                            <td>{data.ApplicationNo}</td>
                            <td>{data.ExhibitorName}</td>
                            <td>{data.CountryName}</td>
                            <td>{data.ChapterNames}</td>
                            <td
                              className="text-center text-aqua"
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                this.getWriteAccess() &&
                                this.onAreaClick(
                                  data.ExhibitionStallSizeID,
                                  data.StallDimension,
                                  data.StallTypeID,
                                  data.Area,
                                  data.ExhRegistrationID,
                                  data.CountryID,
                                  data.ExhibitionID
                                )
                              }
                            >
                              {data.Area}
                            </td>
                            <td
                              className="text-center"
                            >
                              {data.StallDimension}
                            </td>
                            <td
                              className="text-center"
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                this.getWriteAccess() &&
                                this.onOpenSideClick(
                                  data.OpenSides,
                                  data.ExhRegistrationID
                                )
                              }
                            >
                              {console.log('><>><><>>', (data.IsOpenSidePerforma != null &&
                                data.IsOpenSidePerforma != false), !this.getWriteAccess())}
                              <span className="text-center text-aqua">
                                {data.OpenSides}
                              </span>
                            </td>
                            <td
                              className="text-center"
                            >
                              {data["HallNo/StallNo"] != null &&
                                data["HallNo/StallNo"] != "" &&
                                data["HallNo/StallNo"] != "/" ? data["HallNo/StallNo"] : '-'}
                            </td>
                            <td
                              className="text-center"
                              style={{ cursor: "pointer" }}
                            >
                              {
                                <button
                                  type="button"
                                  className="btn  btn-aqua "
                                  disabled={
                                    (!this.getWriteAccess() ? true : data.IsOpenSidePerforma != null &&
                                      data.IsOpenSidePerforma != false)
                                  }
                                  onClick={(e) =>
                                    this.onGenerateOpenSidePI(
                                      data,
                                      data.ExhRegistrationID
                                    )
                                  }
                                >
                                  {/* {console.log('data.IsOpenSidePerforma', data.IsOpenSidePerforma)} */}
                                  {data.IsOpenSidePerforma != null &&
                                    data.IsOpenSidePerforma != false
                                    ? "Generated"
                                    : "Generate  open side PI"}
                                </button>
                              }
                            </td>
                            <td>{data.Scheme}</td>
                            <td
                              className="text-center"
                              style={{ cursor: "pointer" }}
                            >
                              {(data.discount != null && data.discount != "") ||
                                (data.DiscountAmount != null &&
                                  data.DiscountAmount != "") ? (
                                <span
                                  className="text-center text-aqua text-center"
                                  onClick={(e) =>
                                    this.onDiscountClick(
                                      data,
                                      data.ExhRegistrationID
                                    )
                                  }
                                >
                                  {data.discount != null && data.discount != ""
                                    ? `${data.discount}%`
                                    : data.DiscountAmount}
                                </span>
                              ) : (
                                <button
                                  disabled={!this.getWriteAccess()}
                                  type="button"
                                  className="btn  btn-aqua "
                                  onClick={(e) =>
                                    this.onDiscountClick(
                                      data,
                                      data.ExhRegistrationID
                                    )
                                  }
                                >
                                  Discount
                                </button>
                              )}
                            </td>
                            <td className="text-center">
                              {/* <button
                                // type="button"
                                // data-bs-toggle="modal"
                                // data-bs-target="#detail"
                                // onClick={(e) => this.toggleDetailModal()}
                                onClick={(e) =>
                                  this.onDetailsClick(e, data.ExhRegistrationID)
                                }
                              > */}
                              <i
                                disabled={!this.getDownloadAccess()}
                                class="fa fa-file-excel-o rounded-2 export-icon"
                                aria-hidden="true"
                                onClick={(e) =>
                                  this.onDetailsClick(e, data.ExhRegistrationID)
                                }
                              ></i>
                              {/* </button> */}
                            </td>
                            <td className="text-center">
                              {data.isSSICertified ? (
                                <>
                                  <button
                                    // disabled={!this.getWriteAccess()}
                                    type="button"
                                    className="btn  btn-aqua  me-2"
                                  // data-bs-toggle="modal"
                                  // data-bs-target="#detail"

                                  // onClick={(e) => this.toggleDetailModal()}
                                  // onClick={(e) => this.onDetailsClick(e, data.ExhRegistrationID)}
                                  >
                                    <span
                                      className=""
                                      href={data.SSIDocumentPath}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={() => window.open(DOC_BASE_URL + data.SSIDocumentPath, "_blank")}
                                    >
                                      SSI Document
                                    </span>
                                  </button>
                                  <button
                                    // disabled={!this.getWriteAccess()}
                                    type="button"
                                    className="btn  btn-aqua "
                                  // data-bs-toggle="modal"
                                  // data-bs-target="#detail"
                                  // onClick={(e) => this.toggleDetailModal()}
                                  // onClick={(e) => this.onDetailsClick(e, data.ExhRegistrationID)}
                                  >
                                    <span
                                      className=""
                                      href={data.TMMA_ITAMMA_DocumentPath}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={() => window.open(DOC_BASE_URL + data.TMMA_ITAMMA_DocumentPath, "_blank")}
                                    >
                                      {" "}
                                      TMMA-ITAMMA Document
                                    </span>
                                  </button>
                                </>
                              ) : null}
                            </td>
                            {(this.getWriteAccess() || JSON.parse(sessionStorage.getItem("loginDataSS")).UserID == 233) && (
                              <td>
                                {data["HallNo/StallNo"] != null &&
                                  data["HallNo/StallNo"] != "" &&
                                  data["HallNo/StallNo"] != "/" ? (
                                  <span
                                    className="text-center text-aqua"
                                    onClick={(e) =>
                                      this.onHallStallClick(
                                        data,
                                        data.ExhRegistrationID
                                      )
                                    }
                                  >
                                    {data["HallNo/StallNo"]}
                                  </span>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn  btn-aqua "
                                    onClick={(e) =>
                                      this.onGenerateHallNoStallNO(data)
                                    }
                                  >
                                    Generate
                                  </button>
                                )}
                              </td>
                            )}
                            {/* <td>
                                                        {
                                                            data.PriorityNo != null ?
                                                                <span className="text-center text-aqua">{data.PriorityNo}</span> :
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    style={{ padding: "1px 10px" }}
                                                                    onClick={(e) => this.onGenerateClick(data.ExhRegistrationID, data.Outstanding)}
                                                                >
                                                                    Generate
                                                                </button>
                                                        }

                                                    </td> */}
                            <td>
                              {data.FirstRank != null && data.FirstRank != ""
                                ? data.FirstRank
                                : ""}
                            </td>
                            <td>
                              {data.SecondRank != null && data.SecondRank != ""
                                ? data.SecondRank
                                : ""}
                            </td>
                            <td>
                              {data.FinalRank != null && data.FinalRank != ""
                                ? data.FinalRank
                                : ""}
                            </td>
                            <td>
                              {data.PriorityNo != null && data.PriorityNo != ""
                                ? data.PriorityNo
                                : ""}
                            </td>

                            {/* {this.getUpdateAccess() && ( */}
                            <td className="text-center">
                              {this.getWriteAccess() &&
                                <i
                                  // disabled={}
                                  className="fa fa-pencil grid-icon mr-3"
                                  aria-hidden="true"
                                  onClick={(e) => this.handleUpdate(data, false)}
                                />}
                              {this.getReadAccess() && <i
                                // disabled={}
                                className="fa fa-eye grid-icon ms-3"
                                aria-hidden="true"
                                onClick={(e) => this.handleUpdate(data, true)}
                              />}
                            </td>
                            {/* )} */}
                            {this.getSpecialAccess() && (
                              <td className="text-center">
                                {data.isReceiptCreated != 1 &&
                                  data.isRevisedPerformaSent != 1 && (
                                    <button
                                      type="button"
                                      className="btn  btn-aqua "

                                      onClick={(e) =>
                                        this.toggleModalSendRevicesPI(
                                          e,
                                          data.ExhRegistrationID
                                        )
                                      }
                                    >
                                      Generate Revised PI
                                    </button>
                                  )}
                              </td>
                            )}
                            <td className="text-center">
                              {data.isSSICertified ? (
                                data.SSIDiscountStatusID == 1 ? (
                                  <>
                                    <button
                                      type="button"
                                      // disabled={}
                                      className="btn  btn-aqua "
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#detail"
                                      // onClick={(e) => this.toggleDetailModal()}
                                      disabled={!this.getSpecialAccess() ? true : data.SSIDiscountStatusID == 1}
                                    // onClick={(e) => this.toggleModal5(data.ExhRegistrationID, 1)}
                                    >
                                      {" "}
                                      <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Approved SSI Discount
                                    </button>
                                  </>
                                ) : data.SSIDiscountStatusID == 2 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn  btn-aqua "
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#detail"
                                      // onClick={(e) => this.toggleDetailModal()}
                                      disabled={!this.getSpecialAccess()}
                                      onClick={(e) =>
                                        this.toggleModal5(
                                          data.ExhRegistrationID,
                                          1
                                        )
                                      }
                                    >
                                      {" "}
                                      Approve SSI Discount
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger-outline py-1 ms-2"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#detail"
                                      // onClick={(e) => this.toggleDetailModal()}
                                      disabled={
                                        data.SSIDiscountStatusID == 1 ||
                                        data.SSIDiscount
                                      }
                                      onClick={(e) =>
                                        this.toggleModal5(
                                          data.ExhRegistrationID,
                                          2
                                        )
                                      }
                                    >
                                      SSI Document Rejected
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-aqua"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#detail"
                                      // onClick={(e) => this.toggleDetailModal()}
                                      disabled={!this.getSpecialAccess() ? true : data.SSIDiscountStatusID == 1}
                                      onClick={(e) =>
                                        this.toggleModal5(
                                          data.ExhRegistrationID,
                                          1
                                        )
                                      }
                                    >
                                      {" "}
                                      Approve SSI Discount
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger ms-2"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#detail"
                                      // onClick={(e) => this.toggleDetailModal()}
                                      disabled={data.SSIDiscountStatusID == 1 && !this.getSpecialAccess()}
                                      onClick={(e) =>
                                        this.toggleModal5(
                                          data.ExhRegistrationID,
                                          2
                                        )
                                      }
                                    >
                                      Reject SSI Discount
                                    </button>
                                  </>
                                )
                              ) : null}
                            </td>

                            <td className="text-center">
                              {console.log("")}
                              {this.getSpecialAccess() && data["HallNo/StallNo"] != null &&
                                data["HallNo/StallNo"] != "" &&
                                data["HallNo/StallNo"] != "/" && (
                                  <button
                                    type="button"
                                    className="btn  btn-aqua "

                                    onClick={(e) =>
                                      this.sendhallstallUserCred(
                                        e,
                                        data.ExhRegistrationID,
                                        data["HallNo/StallNo"]
                                      )
                                    }
                                  >
                                    send Hall/Stall No
                                  </button>
                                )}
                              {this.getSpecialAccess() && <button
                                type="button"
                                className="btn btn-aqua ms-2 px-2"

                                onClick={(e) =>
                                  this.onOpenAccessControlModal(
                                    0, data.ExhRegistrationID
                                  )
                                }
                              >
                                Access Control
                              </button>}
                              <button
                                type="button"
                                className="btn btn-aqua ms-2 px-2"

                                onClick={(e) =>
                                  this.resendUserCred(
                                    e,
                                    data.ExhRegistrationID,
                                    data.StatusID
                                  )
                                }
                              >
                                Resend UserID & Password
                              </button>
                              {this.getSpecialAccess() &&
                                <button
                                  type="button"
                                  className="btn btn-aqua ms-2"
                                  onClick={(e) => this.onLogin(data)}
                                >
                                  Login
                                </button>
                              }
                            </td>

                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={13} style={{ textAlign: "center" }}>
                            Record not found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="mt-2 float-left trp">
                  {exhibitorList.length > 0 ? (
                    <Pagination
                      nPages={nPages}
                      currentPage={currentPage}
                      setCurrentPage={this.updateItem}
                    />
                  ) : (
                    <></>
                  )}
                  <div className="table-record-pages">
                    <p>{`${currentPage} of ${nPages} pages`}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <Modal isOpen={isOpen2} onRequestClose={(e) => this.toggleModal2(e)}>
          <div
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content estimate-details">
                <div className="modal-header pb-1">
                  <h5 className="modal-title" id="detailLabel">
                    <strong>Generate Hall No / Stall No</strong>
                  </h5>
                  {/* <button
                    type="button"
                    className="btn-close pt-6"
                    data-bs-dismiss="modal"
                    style={{ fontSize: 12 }}
                    aria-label="Close"
                    onClick={(e) => this.setState({ isOpen2: !isOpen2, hallNo: '', stallNo: '', })}
                  /> */}
                  {hallNo != '' && hallNo != null && stallNo != '' && stallNo != null && <button
                    type="button"
                    className="btn btn-gray mb-2"
                    data-bs-dismiss="modal"
                    onClick={(e) =>
                      this.setState({ removeHallStallPop: true })
                    }
                  >
                    Remove Hall No/ Stall No
                  </button>}
                </div>
                <div className="modal-body p-2">
                  <div className="col-xl-6 ms-2">
                    <p>
                      Area: <strong>{this.state.modalArea}sqm</strong>{" "}
                      <button
                        type="button"
                        className="btn btn-gray"
                        data-bs-dismiss="modal"
                        onClick={(e) =>
                          this.onAreaClick(
                            modalData.ExhibitionStallSizeID,
                            modalData.StallDimension,
                            modalData.StallTypeID,
                            modalData.Area,
                            modalData.ExhRegistrationID,
                            modalData.CountryID,
                            modalData.ExhibitionID
                          )
                        }
                      >
                        Change
                      </button>
                    </p>
                    <p>
                      Open Side: <strong>{this.state.modalOpenSide}</strong>{" "}
                      <button
                        type="button"
                        className="btn btn-gray"
                        data-bs-dismiss="modal"
                        onClick={(e) =>
                          this.onOpenSideClick(
                            modalData.OpenSides,
                            modalData.ExhRegistrationID
                          )
                        }
                      >
                        Change
                      </button>
                    </p>
                  </div>
                  <hr></hr>
                  <div className="d-flex">
                    <div className="col-xl-6">
                      <label className="text-left">
                        Hall No <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <input
                                                type="text"
                                                className="form-control"
                                                value={hallNo}
                                                onChange={(e) => this.setState({ hallNo: e.target.value, hallNoErr: "" })}
                                            /> */}
                      <select
                        className="form-control"
                        value={hallNo}
                        // onChange={(e) => this.setState({ hallNo: e.target.value, hallNoErr: "" })}
                        onChange={(e) => this.onHallChange(e, 1)}
                      >
                        <option value={""}>Select Hall</option>
                        {hallList.length > 0 &&
                          hallList.map((data) => (
                            <option key={data.HallId} value={data.HallId}>
                              {data.HallName}
                            </option>
                          ))}
                      </select>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {hallNoErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-6">
                      <label className="text-left">
                        Stall No <span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <input
                                                type="text"
                                                className="form-control"
                                                value={stallNo}
                                                onChange={(e) => this.setState({ stallNo: e.target.value, stallNoErr: "" })}
                                            /> */}
                      <select
                        className="form-control"
                        value={stallNo}
                        disabled={hallNo == "" || hallNo == "Select Hall"}
                        onChange={(e) =>
                          this.setState({
                            stallNo: e.target.value,
                            stallNoErr: "",
                          })
                        }
                      >
                        <option value={""}>Select Stall</option>
                        {stallList.length > 0 &&
                          stallList.map((data) => (
                            <option key={data.StallId} value={data.StallId}>
                              {data.StallName}
                            </option>
                          ))}
                      </select>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {stallNoErr}
                        </span>
                      }
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-xl-6">
                      <label className="text-left">
                        Scheduled Date<span style={{ color: "red" }}>*</span>
                      </label>
                      <DatePicker
                        style={{ zIndex: "99999" }}
                        selected={StallpossessionScheduledDate}
                        minDate={new Date()}
                        dateFormat={"dd/MM/yyyy"}
                        className="form-control"
                        onChange={(date) =>
                          this.setState({
                            StallpossessionScheduledDate: date,
                            StallpossessionScheduledDateErr: "",
                          })
                        }
                        peekNextMonth
                        // maxDate={toDate}
                        // minDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Scheduled Date"
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {StallpossessionScheduledDateErr}
                        </span>
                      }
                    </div>
                  </div>
                  <div className="m-3">
                    {this.state.hallSegmentList.length > 0 && (
                      <table className="table border text-nowrap text-md-nowrap table-bordered ">
                        <thead>
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "60px" }}
                            >
                              Sr no.
                            </th>
                            <th className="text-center">Segment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.hallSegmentList.map((data, i) => (
                            <tr>
                              <td
                                className="text-center"
                                style={{ width: "60px" }}
                              >
                                {i + 1}
                              </td>
                              <td className="text-center">
                                {data.ChapterName}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                <div className="modal-footer p-1">
                  <button
                    type="button"
                    className="btn btn-gray"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.genrateHallStall(e)}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.setState({ isOpen2: !isOpen2, hallNo: '', stallNo: '', })}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={isOpen} onRequestClose={(e) => this.toggleModal(e)}>
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md">
              <div className="modal-content Gen-btnpop">
                <div className="modal-header pb-1">
                  <h5 className="modal-title" id="detailLabel">
                    <strong>Generate Priority No</strong>
                  </h5>
                  <button
                    type="button"
                    className="btn-close pt-6"
                    data-bs-dismiss="modal"
                    style={{ fontSize: 12 }}
                    aria-label="Close"
                    onClick={(e) => this.toggleModal(e)}
                  />
                </div>
                <div className="modal-body ">
                  {exhibitorOutstanding != 0 ? (
                    <p className="text-danger">
                      {" "}
                      The exhibitor has not yet made a 100% payment for the
                      Space Booking.
                    </p>
                  ) : (
                    ""
                  )}
                  {/* <p className=""> The exhibitor has made a 100% payment for the exhibition.</p> */}
                  <hr />

                  <div class="form-check form-check-inline">
                    <label
                      class="form-check-label"
                      for="inlineRadio1"
                      style={{ lineHeight: "15px" }}
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        value={generatePriorityNoType}
                        checked={generatePriorityNoType == 1}
                        onClick={(e) =>
                          this.setState({ generatePriorityNoType: 1 })
                        }
                      />
                      Auto
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <label
                      class="form-check-label"
                      for="inlineRadio2"
                      style={{ lineHeight: "15px" }}
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        id="inlineRadio2"
                        value={generatePriorityNoType}
                        checked={generatePriorityNoType == 0}
                        onClick={(e) =>
                          this.setState({ generatePriorityNoType: 0 })
                        }
                      />
                      Manual
                    </label>
                  </div>

                  {generatePriorityNoType == 0 && (
                    <form>
                      <select
                        class="form-control mt-2"
                        aria-label="Default select example"
                        value={priorityNoId}
                        onChange={(e) =>
                          this.setState({
                            priorityNoId: e.target.value,
                            priorityNoErr: "",
                          })
                        }
                      >
                        <option selected>Select Priority Number</option>
                        {priorityNoList.length > 0 &&
                          priorityNoList.map((data) => (
                            <option key={data.ID} value={data.ID}>
                              {data.PriorityNo}
                            </option>
                          ))}
                      </select>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {priorityNoErr}
                        </span>
                      }
                    </form>
                  )}
                </div>
                <div className="modal-footer p-1">
                  <button
                    type="button"
                    className="btn btn-gray"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.onFinalGeneratePriorityNo(e)}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal isOpen={isOpen3} onRequestClose={(e) => this.toggleModal3(e)}>
          <div className="modal fade show d-block" id="detail">
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content estimate-details">

                {/* Header */}
                <div className="modal-header p-2">
                  <h5 className="modal-title fw-semibold">Change Open Side</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={(e) => this.toggleModal3(e)}
                  />
                </div>

                {/* Body */}
                <div className="modal-body p-2">
                  <div className="row">
                    <div className="col-12">
                      <label>
                        Open Side <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={openSide}
                        onChange={(e) =>
                          this.setState({
                            openSide: e.target.value,
                            openSideErr: "",
                          })
                        }
                      />

                      {openSideErr && (
                        <span className="text-danger d-block mt-1">
                          {openSideErr}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer p-1">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={(e) => this.ChangeOpenSide(e)}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={(e) => this.toggleModal3(e)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>

        </Modal>
        <Modal isOpen={isOpen4} onRequestClose={(e) => this.toggleModal4(e)}>
          <div className="modal fade show d-block" id="detail">
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content estimate-details">

                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title fw-semibold">Change Area</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={(e) => this.toggleModal4(e)}
                  />
                </div>

                {/* Body */}
                <div className="modal-body">

                  {/* Radio buttons */}
                  <div className="row mb-3">
                    {schemeTypeList.map((item) => (
                      <div className="col-6 col-md-4" key={item.Code}>
                        <label className="d-flex align-items-center gap-2">
                          <input
                            type="radio"
                            name="schemeType"
                            checked={schemeType === item.Code}
                            onChange={(e) =>
                              this.onSchemeTypeChange(e, item.Code)
                            }
                          />
                          {item.Description}
                        </label>
                      </div>
                    ))}
                  </div>

                  {/* Dropdown */}
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <label>
                        Length × Width in Meters <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control mt-1"
                        value={stallAreaId}
                        onChange={(e) => this.onLengthTypeChange(e)}
                      >
                        <option value="">Select</option>
                        {stallAreaList.map((area) => (
                          <option key={area.Code} value={area.Code}>
                            {area.Description}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    disabled={
                      !this.state.exhregId ||
                      !stallAreaId ||
                      !this.state.stallArea ||
                      !schemeType ||
                      !stallAreaName
                    }
                    onClick={(e) => this.onUpdateStallTypeArea(e)}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={(e) => this.toggleModal4(e)}
                  >
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>

        </Modal>
        <Modal
          isOpen={this.state.isOpen5}
          onRequestClose={(e) => this.toggleModal5(e)}
        >
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md">
              <div className="modal-content estimate-details">
                <div className="modal-header pb-1">
                  <h5 className="modal-title" id="detailLabel">
                    <strong>
                      SSI Document{" "}
                      {this.state.SSIStatus == 1 ? "Approve" : "Reject"}?
                    </strong>
                  </h5>
                  <button
                    type="button"
                    className="btn-close pt-6"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={(e) => this.toggleModal5(e)}
                  />
                </div>
                {this.state.SSIStatus != 1 && (
                  <div className="modal-body p-2">
                    <div className="d-flex mt-3">
                      <div className="col-xl-12">
                        <label className="text-right">
                          <strong>Reject Reason</strong>
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          value={this.state.RejectReason}
                          onChange={(e) =>
                            this.setState({ RejectReason: e.target.value })
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                )}
                <div className="modal-footer p-1">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.OnSSIDocumentApprove(e)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.toggleModal5(e)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.isOpen6}
          onRequestClose={(e) => this.onDiscountClick(e)}
        >
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md">
              <div className="modal-content estimate-details">
                <div className="modal-header py-1">
                  <h5 className="modal-title" id="detailLabel">
                    <strong>Discount</strong>
                  </h5>
                  <button
                    type="button"
                    className="btn-close pt-6"
                    data-bs-dismiss="modal"
                    style={{ fontSize: 12 }}
                    aria-label="Close"
                    onClick={(e) => this.onDiscountClick(e)}
                  />
                </div>
                <div className="modal-body">
                  <div className="row align-items-end">
                    {/* Discount Percent */}
                    <div className="col-12 col-md-5 mb-2">
                      <label className="text-left">
                        Discount Percent <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={this.state.discountPercent}
                        onChange={(e) => this.onDiscountChange(e, 0)}
                      />
                    </div>

                    {/* OR */}
                    <div className="col-12 col-md-2 text-center mb-3">
                      <strong className="d-block mt-md-4">OR</strong>
                    </div>

                    {/* Discount Amount */}
                    <div className="col-12 col-md-5 mb-2">
                      <label className="text-left">
                        Discount Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={this.state.discountAmt}
                        onChange={(e) => this.onDiscountChange(e, 1)}
                      />
                    </div>
                  </div>

                  {/* Error Message */}
                  {this.state.discountErr && (
                    <span className="text-danger d-block mt-1">
                      {this.state.discountErr}
                    </span>
                  )}
                </div>

                <div className="modal-footer p-1">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.onDiscountSubmit(e)}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    data-bs-dismiss="modal"
                    onClick={(e) => this.onDiscountClick(e)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.isOpen7}
          onRequestClose={(e) => this.onGenerateOpenSidePI(e)}
        >
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md">
              <div className="modal-content estimate-details">
                <div className="modal-body text-center p-4">
                  <h5 className="fw-semibold mb-3 text-aqua" id="detailLabel">
                    Generate OpenSide PI
                  </h5>
                  <p className="small mb-4">
                    Are you sure you want to generate OpenSide PI?
                  </p>
                  <div className="d-flex justify-content-center gap-3">

                    <button
                      type="button"
                      className="btn btn-aqua px-3"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.onPISubmit(e)}
                    >
                      Generate
                    </button>

                    <button
                      type="button"
                      className="btn btn-gray px-4"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.onGenerateOpenSidePI(e)}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={isOpen8}
          onRequestClose={(e) => this.toggleModalSendRevicesPI(e)}
        >
          <div
            className="modal-dialog modal-dialog-centered bd-example-modal-lg"
            id="detail"
          // tabIndex={-1}
          // aria-labelledby="detailLabel"
          // aria-hidden="true"
          >
            <div className="modal-dialog modal-md">
              {!isRevisedPIGenerated ? (
                <div className="modal-content estimate-details">
                  <div className="modal-header pb-1">
                    <h5 className="modal-title" id="detailLabel">
                      <strong>
                        Do you really want to Generate Revised PI to this
                        Exhibitor?
                      </strong>
                    </h5>
                    <button
                      type="button"
                      className="btn-close pt-6"
                      data-bs-dismiss="modal"
                      style={{ fontSize: 12 }}
                      aria-label="Close"
                      onClick={(e) => this.toggleModalSendRevicesPI(e)}
                    />
                  </div>
                  <div className="modal-footer p-1">
                    <button
                      type="button"
                      className="btn btn-aqua"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.generateRevisedPI(e)}
                    >
                      yes
                    </button>
                    <button
                      type="button"
                      className="btn btn-gray"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.toggleModalSendRevicesPI(e)}
                    >
                      No
                    </button>
                  </div>
                </div>
              ) : (
                <div className="modal-content estimate-details">
                  <div className="modal-header pb-1">
                    <h5 className="modal-title" id="detailLabel">
                      <strong>
                        Do you really want to Send Revised PI to this Exhibitor?
                      </strong>
                    </h5>
                    <button
                      type="button"
                      className="btn-close pt-6"
                      data-bs-dismiss="modal"
                      style={{ fontSize: 12 }}
                      aria-label="Close"
                      onClick={(e) => this.toggleModalSendRevicesPI(e)}
                    />
                  </div>
                  <div className="modal-footer p-1">
                    <button
                      type="button"
                      className="btn btn-aqua"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.onViewRevisedPIClick(e)}
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.sendRevisedPI(e)}
                    >
                      Send
                    </button>
                    <button
                      type="button"
                      className="btn btn-gray"
                      data-bs-dismiss="modal"
                      onClick={(e) => this.toggleModalSendRevicesPI(e)}
                    >
                      Back
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.removeHallStallPop} onRequestClose={() => this.setState({ removeHallStallPop: false })}>
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header text-right p-2">
                <h5 className="modal-title" id="detailLabel">
                  Confirm Remove
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  onClick={(e) => this.setState({ removeHallStallPop: false })}

                  aria-label="Close"
                />
              </div>
              <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                <div className="form-row mt-3">

                  <div className="col-md-10">
                    <p class="pop_label">Do you really want to remove Hall no / Stall no?</p>

                  </div>
                </div>
              </div>

              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button type="button" className="btn btn-aqua btn-sm"
                    onClick={(e) => this.removeHallStall(e)}
                  >Yes</button>
                  <button type="button" className="btn btn-gray btn-sm" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ removeHallStallPop: false })}>No</button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.isOpenAc} onRequestClose={() => this.setState({ isOpenAc: false })}
        >
          {/* <div className="modal-dialog">
                                                  <div className="modal-content confirm-logout">
                                                      <div class="modal-header p-2">
                                                          <h5 class="modal-title">Additional Furniture</h5>
                                                          <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                      </div>
                                                      <div>
                                                      </div>
                          
                                                  </div>
                                              </div> */}

          {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

          <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-aqua text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Access Control</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpenAc: false })} ></button>
              </div>
              <div class="modal-body">
                <h5 class="text-dark" style={{ fontSize: "16px" }}>Exhibitor List</h5>
                <div className="table-responsive">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        <th className="text-center">Sr. no</th>
                        <th className="text-center">Exhibitor</th>
                        {hallList.length > 0 && hallList.map((item, i) => (
                          // item.IsActive &&
                          <th className="text-center">{item.HallName}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {currentRecords.length > 0 ? (
                        currentRecords.map((data, index) => ( */}
                      {accessControlList.length > 0 && accessControlList.map((item, i) => (
                        <tr key={Math.random()}>
                          <td className="text-center">
                            {i + 1}
                          </td>
                          <td className="text-center">
                            {item.ExhibitorName}
                          </td>
                          {item.hallList.length > 0 && item.hallList.map((item2, i) => (
                            // item2.IsActive && 
                            <td className="text-center">
                              <Switch
                                onChange={(e) =>
                                  this.onAPClick(item.ExhRegistrationID, item2.HallId
                                  )
                                }
                                checked={
                                  item2.IsAccess
                                }
                                onColor="aqua"
                                offColor="#fff"
                                offHandleColor="#6c757d"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                // disabled={isView}
                                handleDiameter={10} // smaller knob
                                height={14} // smaller height
                                width={28} // smaller width
                                className="me-1 border small-switch"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {accessControlVendorList.length > 0 && <hr />}
                {accessControlVendorList.length > 0 && <h5 class="text-dark" style={{ fontSize: "16px" }}>Non Empanel Vendor List</h5>}
                {accessControlVendorList.length > 0 && <div className="table-responsive">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        <th className="text-center">Sr. no</th>
                        <th className="text-center">Vendor</th>
                        <th className="text-center">Exhibitor</th>
                        {hallList.length > 0 && hallList.map((item, i) => (
                          // item.IsActive &&
                          <th className="text-center">{item.HallName}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {currentRecords.length > 0 ? (
                        currentRecords.map((data, index) => ( */}
                      {accessControlVendorList.length > 0 && accessControlVendorList.map((item, i) => (
                        <tr key={Math.random()}>
                          <td className="text-center">
                            {i + 1}
                          </td>
                          <td className="text-center">
                            {item.CompanyName}
                          </td>
                          <td className="text-center">
                            {item.ExhibitorName}
                          </td>
                          {item.hallList.length > 0 && item.hallList.map((item2, i) => (
                            // item2.IsActive && 
                            <td className="text-center">
                              <Switch
                                onChange={(e) =>
                                  this.onVendorAPClick(item.NonEmpanelVendorID, item2.HallId
                                  )
                                }
                                checked={
                                  item2.IsAccess
                                }
                                onColor="aqua"
                                offColor="#fff"
                                offHandleColor="#6c757d"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                // disabled={isView}
                                handleDiameter={10} // smaller knob
                                height={14} // smaller height
                                width={28} // smaller width
                                className="me-1 border small-switch"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>}
                {/* <div >
                  <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                  <strong>{this.state.exhname}</strong><br /><br />
                </div> */}
                {/* <div>
                  Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                  Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                </div> */}
                {/* <div>
                  Remark: <strong>{this.state.damageRemark}</strong><br />
                </div> */}
                {/* <div>
                  Images<br />
                  {imgarr.length > 0 && imgarr.map(item => (
                    <img
                      onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                      src={item}
                      style={{ margin: '2px', cursor: 'pointer' }}
                      alt="Preview"
                      width="200"
                      height="200"
                    />
                  ))}
                </div> */}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-aqua" onClick={() => this.insertUpdateAP()}>Submit</button>
                <button type="button" class="btn btn-gray" onClick={() => this.setState({ isOpenAc: false })}>Cancel</button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.isOpenCredLog}
          onRequestClose={() => this.toggleCredLogModal()}
        >
          <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-aqua text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Send Credentials Log</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.toggleCredLogModal()} ></button>
              </div>
              <div class="modal-body">
                {(() => {
                  const credLogColumns =
                    exhSendCredLogList.length > 0
                      ? Object.keys(exhSendCredLogList[0]).filter(
                        (key) => !key.endsWith("ID")
                      )
                      : [];
                  const search = credLogSearch.toLowerCase();
                  const filteredCredLogList =
                    search === ""
                      ? exhSendCredLogList
                      : exhSendCredLogList.filter((item) =>
                        credLogColumns.some((key) =>
                          String(item[key] == null ? "" : item[key])
                            .toLowerCase()
                            .includes(search)
                        )
                      );
                  const recordsPerPage = 10;
                  const nPages = Math.ceil(
                    filteredCredLogList.length / recordsPerPage
                  );
                  const startIndex = (credLogCurrentPage - 1) * recordsPerPage;
                  const currentRecords = filteredCredLogList.slice(
                    startIndex,
                    startIndex + recordsPerPage
                  );
                  return (
                    <>
                      <div className="row mb-2">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={credLogSearch}
                            onChange={(e) =>
                              this.setState({
                                credLogSearch: e.target.value,
                                credLogCurrentPage: 1,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th className="text-center">Sr. no</th>
                              {credLogColumns.map((key, i) => (
                                <th className="text-center" key={i}>{key}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {currentRecords.length > 0 ? (
                              currentRecords.map((item, i) => (
                                <tr key={i}>
                                  <td className="text-center">{startIndex + i + 1}</td>
                                  {credLogColumns.map((key, j) => (
                                    <td className="text-center" key={j}>{item[key]}</td>
                                  ))}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td className="text-center" colSpan={20}>No records found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="mt-2 float-left trp">
                        {filteredCredLogList.length > 0 ? (
                          <Pagination
                            nPages={nPages}
                            currentPage={credLogCurrentPage}
                            setCurrentPage={(item) =>
                              this.setState({ credLogCurrentPage: item })
                            }
                          />
                        ) : (
                          <></>
                        )}
                        <div className="table-record-pages">
                          <p>{`${credLogCurrentPage} of ${nPages} pages`}</p>
                        </div>
                      </div>
                    </>
                  );
                })()}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-gray" onClick={() => this.toggleCredLogModal()}>Close</button>
              </div>
            </div>
          </div>
        </Modal>
        {/* <Footerwithdr /> */}
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    exhibitorList_action,
    getExhiitorDetails_action,
    descriptionPreview_action,
    SSIDocumentApproval_action,
    updateStallTypeArea_action,
    viewRevisedPI_action,
    sendUserCred_action,
    fill_action,
    submitManualPriorityNo_action,
    submitAutoPriorityNo_action,
    getExhRegList_action,
    sendRevisedPI_action,
    generateRevisedPI_action,
    generateHallNoStallNo_action,
    generateOpenSide_action,
    addEdirectoryManual_action,
    addFasciaManual_action,
    sendhallstallUserCred_action,
    activateDeactivateExhibitors_action,
    fill_master_action,
    submitDiscount_action,
    submitOpenSidePI_action,
    removedEdirectoryManual_action,
    bulkDescriptionPreview_action, getAPDetails_action,
    insertUpdateAP_action, removeHallStall_action,
    createExhSendCredLog_action,
    getExhSendCredLog_action
  })(ExhibitorList)
);
